webpackJsonp([353,351],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _route = __webpack_require__(1744);
	
	var _route2 = _interopRequireDefault(_route);
	
	var _log = __webpack_require__(1743);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _alert = __webpack_require__(1742);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _style = __webpack_require__(257);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _indicator = __webpack_require__(258);
	
	var _indicator2 = _interopRequireDefault(_indicator);
	
	var _style3 = __webpack_require__(1375);
	
	var _style4 = _interopRequireDefault(_style3);
	
	var _toast = __webpack_require__(1781);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _assign = __webpack_require__(66);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _typeof2 = __webpack_require__(14);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _style5 = __webpack_require__(244);
	
	var _style6 = _interopRequireDefault(_style5);
	
	var _messageBox = __webpack_require__(248);
	
	var _messageBox2 = _interopRequireDefault(_messageBox);
	
	var _tools = __webpack_require__(944);
	
	var _tools2 = _interopRequireDefault(_tools);
	
	var _bluebird = __webpack_require__(957);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _Keyboard = __webpack_require__(1817);
	
	var _Keyboard2 = _interopRequireDefault(_Keyboard);
	
	var _jquery = __webpack_require__(228);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(1783);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(2537);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	__webpack_require__(1741);
	
	var _config = __webpack_require__(576);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _App = __webpack_require__(1815);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(1376);
	
	var _app = __webpack_require__(940);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _dealerCantPath = __webpack_require__(941);
	
	var _dealerCantPath2 = _interopRequireDefault(_dealerCantPath);
	
	var _loginStatus = __webpack_require__(942);
	
	var _loginStatus2 = _interopRequireDefault(_loginStatus);
	
	var _error_handle = __webpack_require__(943);
	
	var _error_handle2 = _interopRequireDefault(_error_handle);
	
	var _base = __webpack_require__(946);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _dynamic = __webpack_require__(947);
	
	var _dynamic2 = _interopRequireDefault(_dynamic);
	
	var _example = __webpack_require__(948);
	
	var _example2 = _interopRequireDefault(_example);
	
	var _nologin = __webpack_require__(949);
	
	var _nologin2 = _interopRequireDefault(_nologin);
	
	var _system = __webpack_require__(950);
	
	var _system2 = _interopRequireDefault(_system);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component(_Keyboard2.default.name, _Keyboard2.default);
	_vue2.default.filter('date', function (date) {
	    var d = new Date(date * 1000);
	    var batchDate = d.getFullYear() + '年' + (d.getMonth() + 1) + '月' + d.getDate() + '日';
	    return batchDate;
	});
	
	_vue2.default.filter('money', function (money) {
	    return money / 100;
	});
	
	_messageBox2.default.confirm = function (message, title, options) {
	    if ((typeof title === 'undefined' ? 'undefined' : (0, _typeof3.default)(title)) === 'object') {
	        options = title;
	        title = '';
	    }
	    return (0, _messageBox2.default)((0, _assign2.default)({
	        title: title || (tools.cache.get('is_vietnam') ? 'Nhắc nhở' : '提示'),
	        message: message,
	        $type: 'confirm',
	        showCancelButton: true,
	        confirmButtonText: tools.cache.get('is_vietnam') ? 'Xác nhận' : '确定',
	        cancelButtonText: tools.cache.get('is_vietnam') ? 'Hủy' : '取消'
	    }, options));
	};
	_messageBox2.default.alert = function (message, title, options) {
	    if ((typeof title === 'undefined' ? 'undefined' : (0, _typeof3.default)(title)) === 'object') {
	        options = title;
	        title = '';
	    }
	    return (0, _messageBox2.default)((0, _assign2.default)({
	        title: title || (tools.cache.get('is_vietnam') ? 'Nhắc nhở' : '提示'),
	        message: message,
	        $type: 'alert',
	        closeOnPressEscape: false,
	        closeOnClickModal: false,
	        confirmButtonText: tools.cache.get('is_vietnam') ? 'Xác nhận' : '确定',
	        cancelButtonText: tools.cache.get('is_vietnam') ? 'Hủy' : '取消'
	    }, options));
	};
	
	var messageBox = _messageBox2.default;
	var toast = _toast2.default;
	var indicator = _indicator2.default;
	_alert2.default.ui.messageBox = messageBox;
	_alert2.default.ui.toast = toast;
	_alert2.default.ui.indicator = indicator;
	
	var tools = _tools2.default;
	var log = _log2.default;
	var alert = _alert2.default;
	var loginStatus = _loginStatus2.default;
	
	tools.errorData = _error_handle2.default.data;
	tools.loginStatus = loginStatus;
	
	tools._ = _underscore2.default;
	
	_route2.default.data.baseRoute = _base2.default;
	_route2.default.data.dynamicRoute = _dynamic2.default;
	_route2.default.data.systemRoute = _system2.default;
	_route2.default.data.exampleRoute = _example2.default;
	
	var app = window;
	
	_tools2.default.vue = _vue2.default;
	_tools2.default.alert = alert;
	
	app.tools = tools;
	app.config = _config2.default;
	app.log = log;
	app.Promise = _bluebird2.default;
	app.app = _app2.default;
	
	_vue2.default.use(_vueRouter2.default);
	
	var routes = _route2.default.routes();
	var router = new _vueRouter2.default({
	    mode: 'history',
	    routes: routes
	});
	
	tools.cache.set('initUrl', location.href);
	if (/(^\/distribution\/(chat))/.test(location.pathname)) {
	    window.wx = null;
	    (0, _jquery2.default)('#weixin').remove();
	    tools.cache.set('Authorization', tools.url.params('token'));
	}
	
	router.beforeEach(function (to, from, next) {
	    var is_vietnam = tools.cache.get('is_vietnam');
	    if (is_vietnam && !/\/vietnam/i.test(to.path)) {
	        tools.router.replace({
	            path: '/vietnam' + to.path,
	            query: {}
	        });
	        next();
	    } else if (!is_vietnam && /\/vietnam/i.test(to.path)) {
	        tools.router.replace({
	            path: to.path.replace(/\/vietnam/i, ''),
	            query: {}
	        });
	    }
	    if (to.path == '/register') {
	        _loginStatus2.default.checkLogin({
	            type: 'login',
	            redirectUrl: '/login',
	            url: to.path,
	            callbackUrl: to.fullPath }, next);
	    } else {
	            _loginStatus2.default.checkLogin({
	                type: 'login',
	                redirectUrl: '/login',
	                url: to.path,
	                callbackUrl: to.fullPath }, next);
	        }
	});
	
	app.tools.router = router;
	
	app.tools.routes = routes;
	
	app.canauthinit = 1;
	
	tools.noLoginUrl = _nologin2.default;
	
	tools.lv0CantPath = _dealerCantPath2.default;
	
	var windowHeight = window.innerHeight;
	_vue2.default.directive('fixedInput', function (el, binding) {
	    el.addEventListener('blur', function () {
	        var windowFocusHeight = window.innerHeight;
	        if (windowHeight == windowFocusHeight) {
	            return;
	        }
	        var currentPosition = void 0;
	        var speed = 1;
	        currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
	        setTimeout(function () {
	            currentPosition -= speed;
	            window.scrollTo(0, currentPosition);
	            currentPosition += speed;
	            window.scrollTo(0, currentPosition);
	        }, 10);
	    });
	});
	
	new _vue2.default({
	    el: '#app',
	    template: '<App/>',
	    components: { App: _App2.default },
	    router: router
	});

/***/ }),

/***/ 244:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 257:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 576:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    environment: 'debug',
	    api: {
	        url: 'http://api.shopdev.shengmingshuo.com',
	
	        websocket: 'ws://sms.huajit.com/ws/chat'
	    },
	    chat: {
	        title: '生命说客服系统'
	    }
	};

/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(18);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            foot_type: null,
	            wrap: false,
	            is_subscribe: 1,
	            is_dealer: 0,
	            img_path: '',
	            is_trditional: false,
	            is_init: true,
	            is_wxjs: true,
	            kefu: {
	                type: 0,
	                id: 0 },
	            show_alert: false,
	            showkefu: false,
	            show_esign: false,
	            areaShow: false,
	            nationCode: {},
	            city: [],
	            show_prop: false,
	
	            is_vietnam: tools.cache.get('is_vietnam'),
	
	            animotion: false,
	            boxActive: 1,
	            shortcut: false,
	            is_wifi: false,
	
	            advertise: {
	                lists: [],
	                back: {},
	                index: 0
	            },
	            bottomValue: 73,
	            rightValue: 12,
	            touchStart: '',
	            touchEnd: '',
	            kfHeight: '',
	            kfWidth: '',
	            bind_superior: false,
	            giftGoods: []
	        };
	    },
	    created: function created() {
	        var _this2 = this;
	
	        var that = this;
	
	        tools.cache.del('isShowpassword');
	        window.HubBus = new tools.vue();
	        window.HubBus.$on('footType', function (type) {
	            that.foot_type = type;
	        });
	        window.HubBus.$on('popup', function (type) {
	            that.show_alert = type;
	        });
	
	        window.HubBus.$on('bindSuperior', function (type) {
	            that.bind_superior = type;
	        });
	        window.HubBus.$on('title', function (text) {
	            document.title = text;
	        });
	        window.HubBus.$on('wxConfig', function (type) {
	            that.is_wxjs = type;
	        });
	        window.HubBus.$on('setKefu', function (obj) {
	            if (!obj) {
	                that.kefu = {
	                    type: 0,
	                    id: 0
	                };
	            } else {
	                that.kefu = obj;
	            }
	        });
	        tools.router.afterEach(function (to, from, next) {
	            if (_this2.is_init) {
	                _this2.is_init = false;
	
	                that.isLogin('/api/islogins');
	            }
	            if (to.path == "/distribution/index" && !tools.cache.get('startIndexData')) {
	                that.isLogin('/api/islogins');
	            }
	        });
	
	        tools.vue.mixin({
	            data: function data() {
	                return {
	                    level_id: 0 };
	            },
	            mounted: function mounted() {
	                var loginData = tools.cache.get('loginData') ? JSON.parse(tools.cache.get('loginData')) : {};
	                this.level_id = loginData.level_id;
	            },
	
	            methods: {
	                thumbnail: function thumbnail(val, size) {
	                    var img_size = '?x-oss-process=image/resize,w_' + size;
	                    return !val ? app.defaultImg() : val + (!size ? '' : img_size);
	                },
	
	                toThumbnail: function toThumbnail(val, size) {
	                    var img_size = '?x-oss-process=image/resize,w_' + size;
	                    return !val ? '' : val + (!size ? '' : img_size);
	                },
	
	                seeImg: function seeImg(imgUrl, arr) {
	                    var imgArr = arr;
	                    if (arr === undefined) {
	                        imgArr = [imgUrl];
	                    }
	                    app.seeImg(imgUrl, imgArr);
	                },
	
	                toUrl: function toUrl(url, val) {
	                    tools.router.push({ path: url, query: val });
	                },
	
	                toReplace: function toReplace(url, val) {
	                    tools.router.replace({ path: url, query: val });
	                },
	                goAuth: function goAuth(callback, type) {
	                    var callback = callback || function () {};
	                    tools.cache.set('is_wechat_login', 1);
	                    tools.loginStatus.check({
	                        is_pay: type || false,
	                        type: 'wechatOauth',
	                        redirectUrl: '/api/wechat/auth',
	                        url: that.$route.path,
	                        callbackUrl: that.$route.fullPath }, callback);
	                }
	            },
	
	            filters: {
	                thumbnail: function thumbnail(val, size) {
	                    return !val ? app.defaultImg() : val + (!size ? '' : size);
	                },
	
	                timeTran: function timeTran(value) {
	                    return !value ? '-' : tools.date('Y-m-d H:i:s', value);
	                },
	
	                setTimeTran: function setTimeTran(value, type) {
	                    return parseInt(value) === 0 ? '-' : tools.date(type, value);
	                },
	
	                toFixedPrice: function toFixedPrice(value) {
	                    return value ? (parseInt(value) / 100).toFixed(2) : '0';
	                },
	
	                priceFormat: function priceFormat(val) {
	                    if (typeof val === 'undefined') {
	                        return;
	                    }
	                    var val_str = '',
	                        val_arr = [];
	                    val_str = val.toString();
	                    val_arr = val_str.split('');
	
	                    if (val_arr.length <= 5) {
	                        return (val / 100).toFixed(2);
	                    } else {
	                        val_arr.splice(val_arr.length - 2, 0, '.');
	                        for (var i = val_arr.length - 4, num = 1; i > 0; i--, num++) {
	                            if (num == 3) {
	                                val_arr.splice(i, 0, ',');
	                                num = 1;
	                                i--;
	                            }
	                        }
	                        return val_arr.join('');
	                    }
	                },
	
	                toPrice: function toPrice(value) {
	                    return value ? parseInt(value) / 100 : '0';
	                },
	                f_status: function f_status(status) {
	                    var txt = '';
	                    var is_vietnam = tools.cache.get('is_vietnam');
	                    switch (Number(status)) {
	                        case -1:
	                            txt = is_vietnam ? 'Toàn bộ trạng thái' : '全部状态';break;
	                        case 0:
	                            txt = is_vietnam ? 'Chờ thanh toán' : '待付款';break;
	                        case 1:
	                            txt = is_vietnam ? 'Chờ giao hàng' : '待发货';break;
	                        case 2:
	                            txt = is_vietnam ? 'Chờ nhận hàng' : '待收货';break;
	                        case 3:
	                            txt = is_vietnam ? 'Đã hoàn thành' : '已完成';break;
	                        case 4:
	                            txt = is_vietnam ? 'Sau bán hàng' : '售后中';break;
	                        case 5:
	                            txt = is_vietnam ? 'Đã đóng' : '已关闭';break;
	                        case 6:
	                            txt = is_vietnam ? 'Hoàn thành sau bán hàng' : '售后完成';break;
	                        case 7:
	                            txt = is_vietnam ? 'Đã hủy' : '已取消';break;
	                        case 8:
	                            txt = is_vietnam ? 'Chờ xét duyệt' : '待审核';break;
	                        case 9:
	                            txt = is_vietnam ? 'Xét duyệt thất bại' : '审核失败';break;
	                        case 10:
	                            txt = is_vietnam ? 'Chờ điền phí vận chuyển' : '待填运费';break;
	                    }
	                    return txt;
	                },
	                levelName: function levelName(val) {
	                    var txt = '';
	                    switch (val) {
	                        case 1:
	                            txt = 'E';break;
	                        case 2:
	                            txt = 'D';break;
	                        case 3:
	                            txt = 'C';break;
	                        case 4:
	                            txt = 'B';break;
	                        case 5:
	                            txt = 'A';break;
	                    }
	                    return txt;
	                }
	            }
	        });
	    },
	
	    name: 'app',
	    watch: {
	        '$route': 'isLinkChange'
	    },
	    methods: {
	        handelBindSuperior: function handelBindSuperior() {
	            this.bind_superior = false;
	            this.toUrl('/binding/bindsuperior', { callbackUrl: this.$route.fullPath });
	        },
	        touchstart: function touchstart(e) {
	            var that = this;
	            if (e.changedTouches.length > 1) {
	                return false;
	            }
	            that.touchStart = e.changedTouches[0];
	            that.kfHeight = that.$refs.kefu.offsetHeight;
	            that.kfWidth = that.$refs.kefu.offsetWidth;
	        },
	        touchmove: function touchmove(e) {
	            e.preventDefault();
	        },
	        touchend: function touchend(e) {
	            var that = this;
	            that.touchEnd = e.changedTouches[0];
	            if (that.touchEnd.clientY - that.touchStart.clientY < 0) {
	                that.bottomValue += (that.touchEnd.clientY - that.touchStart.clientY) * -1;
	                if (that.bottomValue > window.screen.availHeight - that.kfHeight) {
	                    that.bottomValue = window.screen.availHeight - that.kfHeight;
	                }
	            } else {
	                that.bottomValue -= that.touchEnd.clientY - that.touchStart.clientY;
	                if (that.bottomValue < 50) {
	                    that.bottomValue = 50;
	                }
	            }
	            if (that.touchEnd.clientX - that.touchStart.clientX < 0) {
	                that.rightValue += (that.touchEnd.clientX - that.touchStart.clientX) * -1;
	                if (that.rightValue > window.screen.availWidth - that.kfWidth) {
	                    that.rightValue = window.screen.availWidth - that.kfWidth;
	                }
	            } else {
	                that.rightValue -= that.touchEnd.clientX - that.touchStart.clientX;
	                if (that.rightValue < 0) {
	                    that.rightValue = 0;
	                }
	            }
	        },
	        urlChange: function urlChange() {
	            var that = this;
	            var isLogin = tools.cache.get('isLogin');
	            if (isLogin == 1) {
	                that.shortcut = true;
	            }
	            if (that.$route.path == '/distribution/index') {
	                that.boxActive = 2;
	            } else if (that.$route.path == '/distribution/personal/index') {
	                that.boxActive = 1;
	            } else {
	                that.boxActive = 0;
	            }
	
	            var loginData = tools.cache.get('loginData') ? JSON.parse(tools.cache.get('loginData')) : {};
	
	            if (loginData.level_id == 5 && loginData.is_sign == 0 && that.$route.path.indexOf('/contract') < 0) {
	                that.show_esign = true;
	            } else {
	                that.show_esign = false;
	            }
	        },
	        tabActive: function tabActive(index) {
	            this.boxActive = index;
	            this.animotion = !this.animotion;
	            if (index == 1) {
	                this.toUrl('/distribution/personal/index');
	            } else if (index == 2) {
	                this.toUrl('/distribution/index');
	            }
	        },
	        cutNav: function cutNav() {
	            this.animotion = !this.animotion;
	        },
	        toInfo: function toInfo() {
	            this.show_alert = false;
	            this.toUrl('/distribution/improveidentity');
	        },
	        toAddress: function toAddress() {
	            this.show_prop = false;
	            this.toUrl('/address');
	        },
	
	        showLoading: function showLoading() {
	            var that = this;
	
	            console.log('改变了导航:', this.$route);
	            that.is_dealer = tools.cache.get('isDealer');
	
	            that.is_subscribe = 1;
	            that.img_path = tools.cache.get('mpQrcode');
	        },
	        showQRcode: function showQRcode() {
	            var _this = this;
	            _this.wrap = !_this.wrap;
	        },
	        toKefu: function toKefu() {
	            var that = this;
	            if (that.kefu.type == 1) {
	                that.toUrl('/distribution/chat', { goods_id: that.kefu.id });
	            } else if (that.kefu.type == 2) {
	                that.toUrl('/distribution/chat', { order_id: that.kefu.id });
	            } else {
	                that.toUrl('/distribution/chat');
	            }
	        },
	        isShowPopup: function isShowPopup(to) {
	            var that = this;
	            var loginData = tools.cache.get('loginData');
	            if (loginData) {
	                var data = JSON.parse(loginData);
	                if (data.level_id > 2 && data.is_perfect != 1 && to.path !== '/distribution/improveidentity' && to.path !== '/login' && to.path !== '/register') {
	                    that.show_alert = true;
	                }
	            }
	        },
	
	        isLinkChange: function isLinkChange(to) {
	            var that = this;
	            that.urlChange();
	
	            if (this.$route.path == '/update' || this.$route.path == '/register' || this.$route.path == '/goods_promote' || this.$route.path == '/distribution/goodscomb' && tools.url.params('share_from') > 0 || this.$route.path == '/distribution/goodsdetail' && tools.url.params('share_from') > 0 || tools.cache.get('isUser') == 0 || this.$route.path == '/distribution/help/index' || this.$route.path == '/distribution/exchange/index') {
	                that.showkefu = false;
	            } else {
	                that.showkefu = true;
	            }
	            that.is_dealer = tools.cache.get('isDealer');
	
	            that.is_subscribe = 1;
	            that.img_path = tools.cache.get('mpQrcode');
	            that.is_vietnam = tools.cache.get('is_vietnam');
	
	            that.is_wxjs = true;
	
	            that.$nextTick(function () {
	                that.isShowPopup(to);
	                setTimeout(function () {
	                    if (app.device().ios && app.isWeChat() && that.is_wxjs) {
	                        app.wechatjs.ready({
	                            share_title: '生命说商城',
	                            share_img: location.origin + '/static/images/mainproduct.jpg?123',
	                            share_url: tools.cache.get('originUrl'),
	                            share_desc: '全生命周期的健康管理',
	                            is_specific: false
	                        });
	                    }
	
	                    if (!app.device().ios && app.isWeChat() && that.is_wxjs) {
	                        app.wechatjs.config = false;
	                        app.wechatjs.share_config = {
	                            share_title: '生命说商城',
	                            share_img: location.origin + '/static/images/mainproduct.jpg?123',
	                            share_url: location.href,
	                            share_desc: '全生命周期的健康管理',
	                            is_specific: false
	                        };
	                        app.wechatjs.run({
	                            api_url: '/api/wechat/js'
	                        });
	                    }
	                }, 500);
	            });
	        },
	
	        isLogin: function isLogin(url) {
	            var that = this;
	            log.debug('获取是否登录');
	
	            tools.ajax({
	                url: url,
	                ajaxData: {},
	                successFun: function successFun(res) {
	                    tools.cache.set('isUser', res.data.is_user);
	                    tools.cache.set('isDealer', res.data.is_dealer);
	                    localStorage.isDealer = res.data.is_dealer;
	
	                    tools.cache.set('isSubscribe', res.data.is_subscribe);
	                    tools.cache.set('mpQrcode', res.data.mp_qrcode);
	                    tools.cache.set('parent', res.data.parent);
	
	                    that.is_dealer = tools.cache.get('isDealer');
	                    that.img_path = tools.cache.get('mpQrcode');
	
	                    that.is_subscribe = 1;
	                    that.show_prop = res.data.is_address === 0;
	                    if (res.data.is_user == 1 && (that.$route.path == '/' || that.$route.path == '/distribution/index')) {
	                        that.getAdvertiseImg();
	                        that.getGiftGoods();
	                    }
	                },
	                errorFun: function errorFun(error) {
	                    log.error('登录失败!');
	                    tools.alert.error('登录失败!');
	                    tools.cache.set('isLogin', 0);
	                    tools.cache.set('isAuth', 0);
	                },
	                type: 'GET'
	            });
	        },
	
	        toUrl: function toUrl(url, val) {
	            tools.router.push({ path: url, query: val });
	        },
	        fun: function fun(res) {
	            this.nationCode = res;
	        },
	
	        getAdvertiseImg: function getAdvertiseImg() {
	            var that = this;
	            tools.ajax({
	                url: '/api/ads',
	                ajaxData: {
	                    module_type: 2
	                },
	                successFun: function successFun(res) {
	                    if (res.list && res.list.length) {
	                        var data = JSON.parse((0, _stringify2.default)(res.list)),
	                            storageData = [],
	                            lists = [];
	
	                        var startIndexData = tools.cache.get("startIndexData") ? JSON.parse(tools.cache.get("startIndexData")) : [];
	
	                        var _loop = function _loop(v) {
	                            var arr = startIndexData.filter(function (item, index, array) {
	                                return item.id == data[v].id;
	                            });
	                            if (arr && arr.length) {
	                                if (arr[0].gap != data[v].gap || (arr[0].gap ? arr[0].startTime * arr[0].gap * 24 * 60 * 60 * 1000 <= new Date().getTime() : false)) {
	                                    lists.push(data[v]);
	                                }
	                            } else {
	                                lists.push(data[v]);
	                            }
	                        };
	
	                        for (var v = 0; v < data.length; v++) {
	                            _loop(v);
	                        }
	                        if (lists.length <= 0) {
	                            return false;
	                        }
	
	                        for (var i = 0; i < data.length; i++) {
	                            storageData.push({
	                                id: data[i].id,
	                                gap: data[i].gap,
	                                startTime: new Date().getTime()
	                            });
	                        }
	                        tools.cache.set("startIndexData", (0, _stringify2.default)(storageData));
	                        that.advertise.lists = lists;
	                        that.advertise.back = that.advertise.lists[that.advertise.index];
	                    }
	                },
	                errorFun: function errorFun(error) {},
	                type: 'GET'
	            });
	        },
	
	        getGiftGoods: function getGiftGoods() {
	            var that = this;
	            tools.ajax({
	                url: '/api/gift/expire',
	                successFun: function successFun(res) {
	                    console.log(res);
	                    that.giftGoods = res.list;
	                },
	                errorFun: function errorFun(error) {},
	                type: 'GET'
	            });
	        },
	
	        goOutsideUrl: function goOutsideUrl(data) {
	            var that = this;
	            that.advertise.lists = [];
	            if (data.type == 1) {
	                switch (data.skip_type) {
	                    case 1:
	                        that.toUrl('/distribution/goodsdetail', { goods_id: data.skip_id });
	                        break;
	                    case 2:
	                        that.toUrl('/distribution/help/details', { id: data.skip_id });
	                        break;
	                    case 3:
	                        that.toUrl('/retail/personal/message/details', { id: data.skip_id });
	                        break;
	                    case 4:
	                        that.toUrl('/distribution/goodscomb', { goods_id: data.skip_id, is_comb: 1 });
	                        break;
	                    case 5:
	                        that.toUrl('/distribution/material/details', { id: data.skip_id });
	                        break;
	                    case 6:
	                        that.toUrl('/distribution/activity/details', { id: data.skip_id });
	                        break;
	                    case 7:
	                        that.toUrl('/distribution/retail');
	                        break;
	                    case 8:
	                        that.toUrl('/distribution/stock/list', { stock_status: 1 });
	                        break;
	                    case 9:
	                        that.toUrl('/distribution/activity/index');
	                        break;
	                    case 10:
	                        that.toUrl('/distribution/retail', { isSelf: 1 });
	                        break;
	                }
	            } else if (data.type == 2) {
	                if (!data.skip_url) {
	                    return;
	                }
	                location.href = data.skip_url;
	            }
	        },
	        changeBack: function changeBack() {
	            var _this = this;
	            if (_this.advertise.index >= _this.advertise.lists.length - 1) {
	                _this.advertise.lists = [];
	                return;
	            }
	            _this.advertise.index++;
	            _this.advertise.back = _this.advertise.lists[_this.advertise.index];
	        }
	    },
	    mounted: function mounted() {
	        var that = this;
	        that.$nextTick(function () {
	            setTimeout(function () {
	                if (app.device().ios && app.isWeChat() && that.is_wxjs) {
	                    app.wechatjs.config = false;
	
	                    app.wechatjs.share_config = {
	                        share_title: '生命说商城',
	                        share_img: location.origin + '/static/images/mainproduct.jpg?123',
	                        share_url: tools.cache.get('initUrl'),
	                        share_desc: '全生命周期的健康管理',
	                        is_specific: false
	                    };
	                    app.wechatjs.run({
	                        api_url: '/api/wechat/js'
	                    });
	                    wx.getNetworkType({
	                        success: function success(res) {
	                            console.log(111, res.networkType === 'wifi');
	                            that.is_wifi = res.networkType === 'wifi';
	                        }
	                    });
	                }
	            }, 500);
	        });
	    }
	};

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof2 = __webpack_require__(14);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'baseKeyboard',
	    data: function data() {
	        return {
	            show_keyboard: false,
	            show_keyboard_content: false,
	            keyboardValue: []
	        };
	    },
	
	    props: {
	        value: {
	            default: false
	        },
	        callback: {
	            default: function _default(params) {}
	        },
	        title: {
	            type: String,
	            default: '输入数字密码'
	        },
	        exinfo: {
	            type: Object,
	            default: function _default(params) {}
	        }
	    },
	    model: {
	        prop: 'value',
	        event: 'changeValue'
	    },
	    methods: {
	        deleteNum: function deleteNum() {
	            var that = this;
	            that.keyboardValue.splice(that.keyboardValue.length - 1, 1);
	        },
	        chooseNum: function chooseNum(val) {
	            var that = this;
	            that.keyboardValue.push(val);
	            if (that.keyboardValue.length >= 6) {
	                that.keyboardCallback();
	            }
	        },
	        keyboardCallback: function keyboardCallback() {
	            var that = this;
	            if ((0, _typeof3.default)(that.callback)) {
	                that.callback(that.keyboardValue.join(''));
	                that.keyboardValue = [];
	            }
	        },
	        closeKeyboard: function closeKeyboard() {
	            var that = this;
	
	            that.keyboardValue = [];
	            that.$emit('changeValue', false);
	        }
	    },
	    watch: {
	        value: function value(val) {
	            var that = this;
	            if (val) {
	                that.show_keyboard = val;
	                setTimeout(function () {
	                    that.show_keyboard_content = val;
	                }, 0);
	            } else {
	                that.show_keyboard_content = val;
	                setTimeout(function () {
	                    that.show_keyboard = val;
	                }, 200);
	            }
	        }
	    },
	    components: {},
	    filters: {},
	    mounted: function mounted() {
	        var that = this;
	        console.log((0, _typeof3.default)(that.callback));
	    }
	};

/***/ }),

/***/ 940:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _create = __webpack_require__(105);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _assign = __webpack_require__(66);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(172);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _typeof2 = __webpack_require__(14);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    defaultImg: function defaultImg() {
	        var baseimg = "/static/images/lifetalk512.png";
	        return baseimg;
	    },
	
	    isWeChat: function isWeChat() {
	        var ua = window.navigator.userAgent.toLowerCase();
	        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
	            return true;
	        } else {
	            return false;
	        }
	    },
	
	    isAndroid: function isAndroid() {
	        if (/(Android)/i.test(navigator.userAgent)) {
	            return true;
	        } else {
	            return false;
	        };
	    },
	
	    device: function device() {
	        var u = navigator.userAgent,
	            app = navigator.appVersion;
	
	        return {
	            trident: u.indexOf('Trident') > -1,
	            presto: u.indexOf('Presto') > -1,
	            webKit: u.indexOf('AppleWebKit') > -1,
	            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,
	            mobile: !!u.match(/AppleWebKit.*Mobile.*/),
	            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
	            android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1,
	            iPhone: u.indexOf('iPhone') > -1,
	            iPad: u.indexOf('iPad') > -1,
	            webApp: u.indexOf('Safari') == -1,
	            weixin: u.indexOf('MicroMessenger') > -1,
	            qq: u.match(/\sQQ/i) == " qq" };
	    },
	
	    wechatjs: {
	        is_first: true,
	        setShareUrl: function setShareUrl(_url) {
	            if (app.wechatjs.share_config) {
	                app.wechatjs.share_config.share_url = _url;
	            } else {
	                app.wechatjs.share_config = {
	                    share_url: _url
	                };
	            }
	        },
	        run: function run(obj) {
	            var data = {
	                url: obj.api_url,
	                ajax_data: obj.ajax_data || {},
	                api_url: obj.api_url || '/',
	                api_type: obj.api_type || 'POST',
	                api_list: obj.api_list || [],
	                hide_menu_items: obj.hide_menu_items || [],
	                show_menu_items: obj.show_menu_items || [],
	                debug: obj.debug || false
	            };
	
	            data.api_list.push('hideMenuItems');
	            data.api_list.push('showMenuItems');
	
	            data.api_list.push('onMenuShareTimeline');
	            data.api_list.push('onMenuShareAppMessage');
	
	            data.api_list.push('getNetworkType');
	
	            data.api_list.push('scanQRCode');
	
	            app.wechatjs.config = app.wechatjs.config || false;
	            app.wechatjs.share_config = app.wechatjs.share_config || false;
	            if (app.wechatjs.config === false) {
	                if (app.device().ios) {
	                    data.ajax_data['url'] = tools.cache.get('initUrl');
	                } else {
	                    data.ajax_data['url'] = location.href;
	                }
	
	                tools.ajax({
	                    url: data.api_url,
	                    ajaxData: data.ajax_data,
	                    type: data.api_type,
	                    successFun: function successFun(res) {
	                        if (app.wechatjs.is_first) {
	                            tools.cache.set('originUrl', res.data.share_url);
	                            app.wechatjs.is_first = false;
	                        }
	                        if (app.wechatjs.share_config && app.wechatjs.share_config.is_specific) {} else {
	                            app.wechatjs.setShareUrl(res.data.share_url);
	                        }
	
	                        app.wechatjs.config = {
	                            debug: data.debug,
	                            appId: res.data.sign.appId,
	                            timestamp: res.data.sign.timestamp,
	                            nonceStr: res.data.sign.nonceStr,
	                            signature: res.data.sign.signature,
	                            jsApiList: data.api_list
	                        };
	
	
	                        wx.config(app.wechatjs.config);
	
	                        wx.ready(function () {
	                            if (app.wechatjs.share_config !== false) {
	                                wx.onMenuShareTimeline({
	                                    desc: app.wechatjs.share_config.share_desc || '全生命周期的健康管理',
	                                    title: app.wechatjs.share_config.share_title || '生命说商城',
	                                    link: app.wechatjs.share_config.share_url || res.data.share_url,
	                                    imgUrl: app.wechatjs.share_config.share_img || location.origin + '/static/images/mainproduct.jpg?123',
	                                    success: function success() {},
	                                    cancel: function cancel() {}
	                                });
	
	                                wx.onMenuShareAppMessage({
	                                    desc: app.wechatjs.share_config.share_desc || '全生命周期的健康管理',
	                                    title: app.wechatjs.share_config.share_title || '生命说商城',
	                                    link: app.wechatjs.share_config.share_url || res.data.share_url,
	                                    imgUrl: app.wechatjs.share_config.share_img || location.origin + '/static/images/mainproduct.jpg?123',
	                                    type: 'link',
	                                    dataUrl: '',
	                                    success: function success() {},
	                                    cancel: function cancel() {}
	                                });
	                                if (obj.hideAllNonBaseMenuItem) {
	                                    wx.hideAllNonBaseMenuItem();
	                                }
	                                wx.hideMenuItems({
	                                    menuList: data.hide_menu_items });
	
	                                wx.showMenuItems({
	                                    menuList: data.show_menu_items });
	                            }
	
	                            if (app.isWeChat()) {
	                                (function () {
	                                    if ((typeof WeixinJSBridge === 'undefined' ? 'undefined' : (0, _typeof3.default)(WeixinJSBridge)) == "object" && typeof WeixinJSBridge.invoke == "function") {
	                                        handleFontSize();
	                                    } else {
	                                        if (document.addEventListener) {
	                                            document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
	                                        } else if (document.attachEvent) {
	                                            document.attachEvent("WeixinJSBridgeReady", handleFontSize);
	                                            document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
	                                        }
	                                    }
	
	                                    function handleFontSize() {
	                                        WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 });
	
	                                        WeixinJSBridge.on('menu:setfont', function () {
	                                            WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 });
	                                        });
	                                    }
	                                })();
	                            }
	                        });
	                        wx.error(function (res) {});
	                    }
	                });
	            }
	        },
	        ready: function ready(obj) {
	            if (app.wechatjs.config !== false) {
	                wx.ready(function () {
	                    if (app.wechatjs.share_config !== false) {
	                        wx.onMenuShareTimeline({
	                            title: obj.share_title || '生命说商城',
	                            link: obj.share_url,
	                            desc: obj.share_desc || '全生命周期的健康管理',
	                            imgUrl: obj.share_img || app.defaultImg(),
	                            success: function success() {},
	                            cancel: function cancel() {}
	                        });
	
	                        wx.onMenuShareAppMessage({
	                            title: obj.share_title || '生命说商城',
	                            desc: obj.share_desc || '全生命周期的健康管理',
	                            link: obj.share_url,
	                            imgUrl: obj.share_img || app.defaultImg(),
	                            type: 'link',
	                            dataUrl: '',
	                            success: function success() {},
	                            cancel: function cancel() {}
	                        });
	                    }
	                });
	                wx.error(function (res) {
	                    tools.alert.error(res);
	                });
	            }
	        }
	    },
	
	    netWorkType: function netWorkType(params) {
	        var netWorkType = '';
	
	        wx.getNetworkType({
	            success: function success(res) {
	                netWorkType = res.networkType;
	                return netWorkType;
	            }
	        });
	    },
	
	    scanQRCode: function scanQRCode(params, cb) {
	        var param = params || {};
	        wx.scanQRCode({
	            needResult: param.needResult || 0,
	            scanType: param.scanType || ["qrCode", "barCode"],
	            success: function success(res) {
	                var result = res.resultStr;
	                if (typeof params == "function") {
	                    params(result);
	                } else {
	                    cb(result);
	                }
	            }
	        });
	    },
	
	    extend: function extend(origin) {
	        var originProto = (0, _getPrototypeOf2.default)(origin);
	        return (0, _assign2.default)((0, _create2.default)(originProto), origin);
	    },
	
	    seeImg: function seeImg(curSrc, srcList) {
	        if (!curSrc || !srcList || srcList.length == 0) {
	            return;
	        }
	
	        if (this.isWeChat()) {
	            wx.previewImage({
	                'current': curSrc,
	                'urls': srcList
	            });
	        } else {}
	    },
	
	    isArray: function isArray(args) {
	        return Object.prototype.toString.call(args) === "[object Array]";
	    }
	};

/***/ }),

/***/ 941:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    lists: ['/distribution/help/index', '/distribution/help/lis', '/distribution/help/details', '/distribution/invite/index', '/distribution/saleorder/list', '/distribution/saleorder/details', '/distribution/partner/index', '/distribution/partner/partner_message', '/distribution/partner/list', '/distribution/partner/inventory', '/distribution/partner/list2', '/distribution/settle/index', '/distribution/settle/month', '/distribution/settle/year', '/distribution/settle/account', '/distribution/settle/rule', '/distribution/settle/integralhistory', '/distribution/improveidentity'],
	    isUrl: function isUrl(url, type) {
	        var that = this;
	        var url_arr = url.split('?');
	        var flag = false;
	        if (that.lists.indexOf(url_arr[0]) != -1) {
	            flag = true;
	        }
	        console.log(flag, 'flag');
	        return flag;
	    }
	};

/***/ }),

/***/ 942:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(18);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    check: function check(option, next) {
	        var that = this;
	        var option = option || {};
	        var data = {
	            type: option.type || 'wechatOauth',
	            isRedirect: option.isRedirect || 1,
	            redirectUrl: option.redirectUrl || '/login',
	            is_pay: option.is_pay || false,
	            url: option.url || location.pathname,
	            callbackUrl: option.callbackUrl || location.pathname + location.search };
	
	        if (decodeURIComponent(decodeURIComponent(option.callbackUrl)) == data.url && data.url == '/login') {
	            data.callbackUrl = '/distribution/personal/index';
	        }
	
	        var _callbackUrl = decodeURIComponent(decodeURIComponent(option.callbackUrl));
	
	        if (tools.isEmpty(tools.cache.get('Authorization')) && window.canauthinit == 1) {
	            that.getSign(option, next);
	        } else if (!tools.isEmpty(tools.cache.get('Authorization'))) {
	            if (tools.url.params('usertest') && config.environment === 'debug') {
	                next();
	                return;
	            }
	
	            if (tools.cache.get('is_wechat_login') == 1) {
	                tools.cache.set('is_wechat_login', 2);
	                console.log('is_wechat_login');
	                var callback = location.origin + data.callbackUrl;
	
	
	                var share_from = '';
	                if (tools.url.params('share_from') !== undefined && !isNaN(tools.url.params('share_from'))) {
	                    share_from = '&share_from=' + tools.url.params('share_from');
	                }
	                var url = window.config.api.url + data.redirectUrl + '?callback=' + encodeURIComponent(callback) + '&token=' + tools.cache.get('Authorization') + '&type=' + 'mp' + share_from;
	                if (data.is_pay) {
	                    url = url + '&is_pay=1';
	                }
	                if (!tools.isEmpty(tools.url.params('testuser'))) {
	                    url += '&testuser=' + tools.url.params('testuser');
	                }
	
	                tools.cache.set('isLogin', 2);
	
	                window.location.href = url;
	            } else if (tools.cache.get('is_wechat_login') == 2 && tools.cache.get('isLogin') == 2) {
	                that.isLogin('/api/islogins', option, next);
	            } else if (tools.cache.get('isLogin') == 0 || tools.cache.get('isLogin') == undefined) {
	                    if (data.isRedirect === 1 && data.type == 'login' && !tools.noLoginUrl.isUrl(data.url)) {
	                        var url = data.callbackUrl;
	                        tools.router.push({ path: data.redirectUrl, query: { callback: url } });
	                    } else if (tools.noLoginUrl.isUrl(data.url)) {
	                        if (typeof next == 'function') {
	                            next();
	                            return;
	                        }
	                    } else if (data.url.toLowerCase() == '/distribution/chat' && !!tools.url.params('token')) {
	                        if (typeof next == 'function') {
	                            next();
	                        }
	                    } else if (data.type == 'wechatOauth') {
	                        console.log('wechatOauth123456');
	
	                        var callback = location.origin + data.callbackUrl;
	
	                        if (option.callbackUrl.toLowerCase().indexOf('/register') == 0) {} else if (tools.cache.get('isAuth') == 1) {
	                            if (tools.cache.get('isUser') == 0 && option.callbackUrl.toLowerCase().indexOf('/register') != 0) {
	                                tools.router.push({ path: '/bind_wechat', query: { callback: option.callbackUrl } });
	                            } else if (next != undefined) {
	                                next();
	                            } else {
	                                tools.router.push({ path: option.callbackUrl });
	                            }
	                            return;
	                        }
	
	                        var share_from = '';
	                        if (tools.url.params('share_from') !== undefined && !isNaN(tools.url.params('share_from'))) {
	                            share_from = '&share_from=' + tools.url.params('share_from');
	                        }
	                        var url = window.config.api.url + data.redirectUrl + '?callback=' + encodeURIComponent(callback) + '&token=' + tools.cache.get('Authorization') + '&type=' + 'mp' + share_from;
	                        if (!tools.isEmpty(tools.url.params('testuser'))) {
	                            url += '&testuser=' + tools.url.params('testuser');
	                        }
	
	                        tools.cache.set('isLogin', 2);
	
	                        window.location.href = url;
	                    } else if (data.type == 'login') {
	                        that.isLogin('/api/islogins', option, next);
	                    }
	                    return false;
	                } else if (tools.cache.get('isLogin') == 2) {
	                        that.isLogin('/api/islogins', option, next);
	                    } else {
	                            that.authPath(option, next);
	                        }
	        }
	    },
	    authPath: function authPath(option, next) {
	        var is_dealer = localStorage.isDealer,
	            is_user = tools.cache.get('isUser'),
	            parent = tools.cache.get('parent'),
	            is_perfect = tools.cache.get('isPerfect');
	        var dealer0_path = /(^\/distribution\/(identityauth|register|chat|goodsdetail))/i,
	            dealer1_canpath = /(^\/retail\/(cart|info|(order\/activitydetail\/index)|(personal\/(?!.*?index))))/i,
	            dealer1_path = /(^((\/index)|(\/$)|($)|(\/(\?))|\/goodsdetail|\/identityauth|(\/distribution\/(register|testgoods))|(\/retail\/)))/i,
	            dealer2_path = /(^\/distribution\/(index|identityauth|improveidentity|personal|goodsdetail|wallet|stock|goodsorder|question|testgoods|materialorder|chat))/i;
	        option.callbackUrl = decodeURIComponent(decodeURIComponent(option.callbackUrl));
	
	        if (/^\/distribution\/chat/i.test(option.callbackUrl)) {
	            next();
	            return;
	        }
	        if (/^\/goodsdetail_share/i.test(option.callbackUrl)) {
	            next();
	            return;
	        }
	        if (/^\/bind_wechat/i.test(option.callbackUrl)) {
	            if (is_user == 0) {
	                next();
	                return;
	            }
	        }
	        if (/^\/register/i.test(option.callbackUrl)) {
	            if (typeof next == 'function') {
	                next();
	                return;
	            }
	            if (is_user == 0) {
	                next();
	                return;
	            } else if (is_dealer == 0 || is_dealer == 3) {
	                next();
	                return;
	            } else if (is_dealer == 1 || is_dealer == 2) {
	                tools.router.replace({ path: '/distribution/personal/index' });
	            } else if (typeof next == 'function') {
	                    next();
	                }
	        } else if (/^\/login/i.test(option.callbackUrl)) {
	            next();
	            return;
	        } else {
	            if (is_user == 0 && tools.cache.get('is_wechat_login') != 2) {
	                tools.router.replace({ path: '/bind_wechat', query: { callback: option.callbackUrl } });
	            } else if (is_dealer == 0 && tools.cache.get('parent') == 1) {
	                if (dealer0_path.test(option.callbackUrl)) {
	                    next();
	                } else {
	                    next();
	                }
	            } else if (is_dealer == 0 && /^\/distribution/i.test(option.callbackUrl) && !/^\/distribution\/goodscomb/i.test(option.callbackUrl)) {
	                if (tools.lv0CantPath.isUrl(option.callbackUrl)) {
	                    tools.router.replace({ path: '/distribution/personal/index' });
	                } else {
	                    next();
	                }
	            } else if (tools.cache.get('parent') == 0 && /^\/yunindex/i.test(option.callbackUrl)) {
	                tools.router.replace({ path: '/index' });
	            } else if (is_dealer == 1 && dealer1_canpath.test(option.callbackUrl)) {
	                next();
	            } else if (is_dealer == 2 && (dealer1_canpath.test(option.callbackUrl) || dealer1_path.test(option.callbackUrl))) {
	                next();
	            } else if ((is_dealer == 1 || is_dealer == 2) && dealer1_path.test(option.callbackUrl)) {
	                tools.router.replace({ path: '/distribution/personal/index' });
	            } else if (is_dealer == 2) {
	                next();
	            } else if (typeof next == 'function') {
	                next();
	            }
	        }
	    },
	
	    getSign: function getSign(option, next) {
	        var that = this;
	        log.debug('开始获取签名');
	        window.canauthinit = 0;
	        var token = tools.url.params('token');
	        if (/(^\/distribution\/(chat))/i.test(option.callbackUrl) && token) {
	            tools.cache.set('Authorization', token);
	
	            that.check(option, next);
	            window.canauthinit = 1;
	        } else {
	            tools.ajax({
	                url: '/api/init',
	                ajaxData: {},
	                successFun: function successFun(response) {
	                    log.debug('获取到签名:', response);
	                    tools.cache.set('Authorization', response.token);
	
	                    that.check(option, next);
	
	                    window.canauthinit = 1;
	                },
	                errorFun: function errorFun(error) {
	                    log.error('获取签名失败');
	                    window.canauthinit = 1;
	                },
	                type: 'GET'
	            });
	        }
	    },
	
	    isLogin: function isLogin(url, option, next) {
	        var that = this;
	        log.debug('loginStatus获取是否登录');
	        tools.ajax({
	            url: url,
	            ajaxData: {},
	            successFun: function successFun(res) {
	                tools.cache.set('isUser', res.data.is_user);
	                tools.cache.set('isDealer', res.data.is_dealer);
	                tools.cache.set('level', res.data.level_id);
	                localStorage.isDealer = res.data.is_dealer;
	
	                tools.cache.set('isSubscribe', res.data.is_subscribe);
	                tools.cache.set('mpQrcode', res.data.mp_qrcode);
	                tools.cache.set('parent', res.data.parent);
	                tools.cache.set('isPerfect', res.data.is_perfect);
	                tools.cache.set('isOpenGroup', res.data.is_open_group);
	                tools.cache.set('isAuth', res.data.is_wechat_auth);
	                tools.cache.set('isPay', res.data.is_pay);
	
	                if (tools.noLoginUrl.isUrl(option.callbackUrl)) {
	                    if (typeof next == 'function') {
	                        next();
	                    }
	                } else if (option.callbackUrl.toLowerCase() == '/distribution/chat' && !!tools.url.params('token')) {
	                    if (typeof next == 'function') {
	                        next();
	                    }
	                } else if (option.type == 'wechatOauth') {
	                    var canAccessPath = /(^\/(register))/i;
	                    if (canAccessPath.test(option.callbackUrl)) {
	                        next();
	                        return;
	                    } else if (res.data.is_wechat_auth == 1 && res.data.is_user == 0) {
	                        tools.cache.set('isLogin', 0);
	                        tools.cache.set('isAuth', 1);
	
	                        tools.cache.set('isLogin', 1);
	                        tools.router.replace({ 'path': '/bind_wechat', query: { type: 2, is_wechat: 1, callback: option.callbackUrl } });
	                    } else if (res.data.is_wechat_auth == 0 && res.data.is_user == 0) {
	                        tools.cache.set('isAuth', 0);
	                        tools.cache.set('isLogin', 0);
	
	                        that.check(option, next);
	                        return;
	                    } else if (res.data.is_user == 1) {
	                        tools.cache.set('isAuth', 1);
	                        tools.cache.set('isLogin', 1);
	
	                        if (option.url == '/login') {
	                            var cburl = tools.url.params('callback');
	
	                            tools.router.replace({ 'path': cburl ? decodeURIComponent(decodeURIComponent(cburl)) : '/distribution/personal/index' });
	                        } else {
	                            that.authPath(option, next);
	                        }
	                    }
	                } else if (option.type == 'login') {
	                    var canAccessPath = /(^\/(register))/i;
	                    if (canAccessPath.test(option.callbackUrl)) {
	                        next();
	                        return;
	                    } else if (res.data.is_user == 0) {
	                        tools.cache.set('isLogin', 0);
	                        tools.router.replace({ 'path': '/bind_wechat', query: { type: 2, is_wechat: 1, callback: option.callbackUrl } });
	                    } else if (res.data.is_user == 1) {
	                        tools.cache.set('isLogin', 1);
	                        if (option.url == '/login') {
	                            var cburl = tools.url.params('callback');
	
	                            tools.router.replace({ 'path': cburl ? decodeURIComponent(decodeURIComponent(cburl)) : '/distribution/personal/index' });
	                        } else {
	                            that.authPath(option, next);
	                        }
	                    }
	                }
	            },
	            errorFun: function errorFun(error) {
	                log.error('登录失败!');
	                tools.alert.error('登录失败!');
	                tools.cache.set('isLogin', 0);
	                tools.cache.set('isAuth', 0);
	
	                tools.cache.set('isUser', '');
	                tools.cache.set('username', '');
	                tools.cache.set('userId', '');
	                tools.cache.set('isDealer', '');
	                tools.cache.set('isPerfect', '');
	                tools.cache.set('parent', '');
	                tools.cache.set('loginState', '');
	                tools.cache.set('is_wechat_login', '');
	
	                tools.cache.set('level', '');
	                localStorage.Authorization = '';
	                localStorage.isLogin = '';
	                localStorage.isDealer = '';
	
	                that.check(option, next);
	            },
	            type: 'GET'
	        });
	    },
	    checkLogin: function checkLogin(option, next) {
	        var that = this;
	        log.debug('获取是否登录 loginStatus:439');
	
	        tools.ajax({
	            url: '/api/islogins',
	            ajaxData: {},
	            successFun: function successFun(res) {
	                tools.cache.set('loginData', (0, _stringify2.default)(res.data));
	                tools.cache.set('isUser', res.data.is_user);
	                tools.cache.set('level', res.data.level_id);
	                tools.cache.set('isDealer', res.data.is_dealer);
	                localStorage.isDealer = res.data.is_dealer;
	
	                tools.cache.set('isSubscribe', res.data.is_subscribe);
	                tools.cache.set('mpQrcode', res.data.mp_qrcode);
	                tools.cache.set('parent', res.data.parent);
	                tools.cache.set('isPerfect', res.data.is_perfect);
	                tools.cache.set('isOpenGroup', res.data.is_open_group);
	                tools.cache.set('isAuth', res.data.is_wechat_auth);
	                tools.cache.set('isPay', res.data.is_pay);
	
	                if (res.data.typeface == 2) {
	                    tools.cache.set('is_traditional', 1);
	                }
	
	                if (res.data.is_testing == 1) {
	                    if (option.url == '/update') {
	                        next();
	                        return;
	                    }
	                    tools.router.replace({ 'path': '/update' });
	
	                    tools.router.replace({ 'path': '/update' });
	                    return;
	                } else if (!res.data.is_testing && option.url == '/update') {
	                    tools.router.replace({ 'path': '/' });
	                    return;
	                }
	
	                if (tools.noLoginUrl.isUrl(option.url)) {
	                    if (typeof next == 'function') {
	                        next();
	                    }
	                } else if (option.callbackUrl.toLowerCase() == '/distribution/chat' && !!tools.url.params('token')) {
	                    if (typeof next == 'function') {
	                        next();
	                    }
	                } else if (option.type == 'wechatOauth') {
	
	                    if (res.data.is_wechat_auth == 1 && res.data.is_user == 0) {
	                        tools.cache.set('isLogin', 0);
	                        tools.cache.set('isAuth', 1);
	                        if (decodeURIComponent(decodeURIComponent(option.callbackUrl)) == '/bind_wechat') {
	                            next();
	                        } else {
	                            that.check(option, next);
	                            return;
	                        }
	                    } else if (res.data.is_wechat_auth == 0 && res.data.is_user == 0) {
	                        tools.cache.set('isAuth', 0);
	                        tools.cache.set('isLogin', 0);
	
	                        that.check(option, next);
	                        return;
	                    } else if (res.data.is_user == 1) {
	                        tools.cache.set('isAuth', 1);
	                        tools.cache.set('isLogin', 1);
	                        if (option.url == '/login') {
	                            var cburl = tools.url.params('callback');
	
	                            tools.router.replace({ 'path': cburl ? decodeURIComponent(decodeURIComponent(cburl)) : '/distribution/personal/index' });
	                        } else {
	                            that.authPath(option, next);
	                        }
	                    }
	                } else if (option.type == 'login') {
	                    var canAccessPath = /(^\/(register))/i;
	                    if (canAccessPath.test(option.callbackUrl)) {
	                        next();
	                        return;
	                    } else if (res.data.is_user == 0) {
	                        tools.cache.set('isLogin', 0);
	                        tools.router.replace({ 'path': '/bind_wechat', query: { callback: option.callbackUrl } });
	                    } else if (res.data.is_user == 1) {
	                        tools.cache.set('isLogin', 1);
	                        if (option.url == '/login') {
	                            var cburl = tools.url.params('callback');
	
	                            tools.router.replace({ 'path': cburl ? decodeURIComponent(decodeURIComponent(cburl)) : '/distribution/personal/index' });
	                        } else {
	                            that.authPath(option, next);
	                        }
	                    }
	                } else {
	                    that.check(option, next);
	                }
	            },
	            errorFun: function errorFun(error) {
	                log.error('登录失败!');
	                tools.alert.error('登录失败!');
	                tools.cache.set('isLogin', 0);
	                tools.cache.set('isAuth', 0);
	
	                tools.cache.set('isUser', '');
	                tools.cache.set('username', '');
	                tools.cache.set('userId', '');
	                tools.cache.set('isDealer', '');
	                tools.cache.set('isPerfect', '');
	                tools.cache.set('parent', '');
	                tools.cache.set('loginState', '');
	                tools.cache.set('is_wechat_login', '');
	                tools.cache.set('level', '');
	                localStorage.isLogin = '';
	                localStorage.isDealer = '';
	            },
	            type: 'GET'
	        });
	    }
	};

/***/ }),

/***/ 943:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	var is_init = true;
	exports.default = {
	    data: [{
	        errcode: 'AUTHORIZATION_INVALID',
	
	        url: true,
	        fun: function fun() {
	            var that = this;
	
	            if (!is_init) {
	                return false;
	            }
	
	            is_init = false;
	
	            if (tools.url.params('token') && /(^\/distribution\/(chat))/i.test(location.href)) {
	                next();
	            }
	
	            localStorage.Authorization = '';
	            tools.cache.set('isLogin', 0);
	            tools.ajax({
	                url: '/api/init',
	                ajaxData: {},
	                successFun: function successFun(response) {
	                    tools.cache.set('Authorization', response.token);
	
	                    tools.cache.set('isAuth', 0);
	                    is_init = true;
	                },
	                errorFun: function errorFun(error) {
	                    log.error('获取签名失败');
	                },
	                type: 'GET'
	            });
	        }
	    }, {
	        errcode: 'NO LOGIN',
	
	        url: true,
	        fun: function fun() {
	            if (!is_init) {
	                return false;
	            }
	
	            is_init = false;
	
	            window.tools.cache.set('isLogin', 0);
	            window.tools.cache.set('isAuth', 0);
	
	            window.tools.cache.set('isUser', '');
	            window.tools.cache.set('username', '');
	            window.tools.cache.set('userId', '');
	            window.tools.cache.set('isDealer', '');
	            localStorage.isDealer = '';
	            window.tools.cache.set('isPerfect', '');
	            window.tools.cache.set('parent', '');
	            window.tools.cache.set('loginState', '');
	            window.tools.cache.set('is_wechat_login', '');
	
	            window.tools.cache.set('level', '');
	            localStorage.Authorization = '';
	
	            var __url = '';
	            if (location.href.indexOf('?') != '-1') {
	                __url = location.href.substring(location.href.indexOf('?'));
	            }
	            var url = tools.router.currentRoute.path + __url;
	            console.log('err', url);
	
	            tools.loginStatus.checkLogin({
	                type: 'login',
	                redirectUrl: '/login',
	                url: tools.router.currentRoute.path,
	                callbackUrl: url });
	        }
	    }]
	
	};

/***/ }),

/***/ 944:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getOwnPropertyNames = __webpack_require__(951);
	
	var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);
	
	var _typeof2 = __webpack_require__(14);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _axios = __webpack_require__(259);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    errorData: [],
	
	    loginStatus: {},
	
	    noLoginUrl: [],
	
	    axios: _axios2.default,
	
	    ajax: function ajax(option) {
	        var that = this;
	        var d = $.extend(true, {}, option);
	
	        var usertest = '';
	        if (that.url.params('usertest') && config.environment === 'debug') {
	            if (option.url.match('[\?]')) {
	                usertest = '&usertest=' + that.url.params('usertest');
	            } else {
	                usertest = '?usertest=' + that.url.params('usertest');
	            }
	        }
	
	        var url = option.url !== undefined ? window.config.api.url + option.url + usertest : '/';
	        if (option.url == '/api/upload') {
	            tools.alert.loading();
	        }
	        var data = {
	            url: url,
	            ajaxData: option.ajaxData || {},
	            successFun: option.successFun || '',
	            errorFun: option.errorFun || '',
	            type: option.type || 'POST',
	            timeout: option.timeout || 10000,
	            isLoading: option.isLoading || 0
	        };
	
	        data.params = {};
	        data.data = {};
	        if (data.type == 'GET') {
	            data.params = data.ajaxData;
	        } else {
	            data.data = data.ajaxData;
	        }
	
	        var authorization = this.cache.get('Authorization') || '';
	
	
	        if (data.isLoading) {
	            tools.alert.loading();
	        }
	        var headers = {
	            'X-ISAPI': 1,
	            'Authorization': authorization
	        };
	        if (tools.cache.get('is_vietnam')) {
	            headers['IS-VIETNAM'] = 1;
	        }
	
	        return (0, _axios2.default)({
	            method: data.type,
	            url: data.url,
	            params: data.params,
	            data: data.data,
	            timeout: data.timeout,
	            withCredentials: config.withCredentials,
	            headers: headers
	        }).then(function (response) {
	
	            if (data.isLoading) {
	                tools.alert.closeLoading();
	            }
	
	            if (typeof data.successFun == 'function') {
	                try {
	                    return data.successFun(response.data);
	                } catch (e) {
	                    log.error(e);
	                }
	            }
	        }, function (error) {
	            tools.alert.closeLoading();
	
	            if (!error.response) {
	                console.log('Error', error.message);
	
	                if (error.message.indexOf('timeout') >= 0) {
	                    tools.alert.error(config.language === 'English' ? "Network error, please reflash this page ." : '接口超时,请尝试刷新页面后重试!');
	                    return;
	                } else {}
	            }
	
	            var status = error.response.status;
	            var error_data = error.response.data;
	            var headers = error.response.headers;
	            var errcode = error_data.error_code;
	
	            if (status === 500) {
	                error_data.error_msg = error_data.request_id ? '系统开小差了。request_id：' + error_data.request_id : '系统开小差了';
	            }
	
	            if (that.errorHandle({ errcode: errcode, option: d })) {
	                if (typeof data.errorFun == 'function') {
	                    try {
	                        return data.errorFun(error_data, status, headers, error);
	                    } catch (e) {
	                        log.error(e);
	                    }
	                }
	            }
	        }).catch(function (error) {
	            log.error(error);
	        });
	    },
	
	    trim: function trim(str) {
	        str = str.toString() || '';
	        return str.replace(/(^\s*)|(\s*$)/g, '');
	    },
	
	    date: function (_date) {
	        function date(_x, _x2) {
	            return _date.apply(this, arguments);
	        }
	
	        date.toString = function () {
	            return _date.toString();
	        };
	
	        return date;
	    }(function (format, timestamp) {
	        if (!timestamp) return;
	        var timestamp = timestamp.toString().length === 10 ? Number(timestamp) * 1000 : timestamp;
	        var jsdate = timestamp ? new Date(timestamp) : new Date();
	        var pad = function pad(n, c) {
	            if ((n = n + "").length < c) {
	                return new Array(++c - n.length).join("0") + n;
	            } else {
	                return n;
	            }
	        };
	        var txt_weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
	        var txt_ordin = { 1: "st", 2: "nd", 3: "rd", 21: "st", 22: "nd", 23: "rd", 31: "st" };
	        var txt_months = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	
	        var f = {
	            d: function d() {
	                return pad(f.j(), 2);
	            },
	            D: function D() {
	                t = f.l();
	                return t.substr(0, 3);
	            },
	            j: function j() {
	                return jsdate.getDate();
	            },
	            l: function l() {
	                return txt_weekdays[f.w()];
	            },
	            N: function N() {
	                return f.w() + 1;
	            },
	            S: function S() {
	                return txt_ordin[f.j()] ? txt_ordin[f.j()] : 'th';
	            },
	            w: function w() {
	                return jsdate.getDay();
	            },
	            z: function z() {
	                return (jsdate - new Date(jsdate.getFullYear() + "/1/1")) / 864e5 >> 0;
	            },
	
	            W: function W() {
	                var a = f.z(),
	                    b = 364 + f.L() - a;
	                var nd2,
	                    nd = (new Date(jsdate.getFullYear() + "/1/1").getDay() || 7) - 1;
	
	                if (b <= 2 && (jsdate.getDay() || 7) - 1 <= 2 - b) {
	                    return 1;
	                } else {
	
	                    if (a <= 2 && nd >= 4 && a >= 6 - nd) {
	                        nd2 = new Date(jsdate.getFullYear() - 1 + "/12/31");
	                        return date("W", Math.round(nd2.getTime() / 1000));
	                    } else {
	                        return 1 + (nd <= 3 ? (a + nd) / 7 : (a - (7 - nd)) / 7) >> 0;
	                    }
	                }
	            },
	
	            F: function F() {
	                return txt_months[f.n()];
	            },
	            m: function m() {
	                return pad(f.n(), 2);
	            },
	            M: function M() {
	                t = f.F();
	                return t.substr(0, 3);
	            },
	            n: function n() {
	                return jsdate.getMonth() + 1;
	            },
	            t: function t() {
	                var n;
	                if ((n = jsdate.getMonth() + 1) == 2) {
	                    return 28 + f.L();
	                } else {
	                    if (n & 1 && n < 8 || !(n & 1) && n > 7) {
	                        return 31;
	                    } else {
	                        return 30;
	                    }
	                }
	            },
	
	            L: function L() {
	                var y = f.Y();
	                return !(y & 3) && (y % 1e2 || !(y % 4e2)) ? 1 : 0;
	            },
	
	            Y: function Y() {
	                return jsdate.getFullYear();
	            },
	            y: function y() {
	                return (jsdate.getFullYear() + "").slice(2);
	            },
	
	            a: function a() {
	                return jsdate.getHours() > 11 ? "pm" : "am";
	            },
	            A: function A() {
	                return f.a().toUpperCase();
	            },
	            B: function B() {
	                var off = (jsdate.getTimezoneOffset() + 60) * 60;
	                var theSeconds = jsdate.getHours() * 3600 + jsdate.getMinutes() * 60 + jsdate.getSeconds() + off;
	                var beat = Math.floor(theSeconds / 86.4);
	                if (beat > 1000) beat -= 1000;
	                if (beat < 0) beat += 1000;
	                if (String(beat).length == 1) beat = "00" + beat;
	                if (String(beat).length == 2) beat = "0" + beat;
	                return beat;
	            },
	            g: function g() {
	                return jsdate.getHours() % 12 || 12;
	            },
	            G: function G() {
	                return jsdate.getHours();
	            },
	            h: function h() {
	                return pad(f.g(), 2);
	            },
	            H: function H() {
	                return pad(jsdate.getHours(), 2);
	            },
	            i: function i() {
	                return pad(jsdate.getMinutes(), 2);
	            },
	            s: function s() {
	                return pad(jsdate.getSeconds(), 2);
	            },
	
	            O: function O() {
	                var t = pad(Math.abs(jsdate.getTimezoneOffset() / 60 * 100), 4);
	                if (jsdate.getTimezoneOffset() > 0) t = "-" + t;else t = "+" + t;
	                return t;
	            },
	            P: function P() {
	                var O = f.O();
	                return O.substr(0, 3) + ":" + O.substr(3, 2);
	            },
	
	            c: function c() {
	                return f.Y() + "-" + f.m() + "-" + f.d() + "T" + f.h() + ":" + f.i() + ":" + f.s() + f.P();
	            },
	
	            U: function U() {
	                return Math.round(jsdate.getTime() / 1000);
	            }
	        };
	
	        return format.replace(/[\\]?([a-zA-Z])/g, function (t, s) {
	            var ret;
	            if (t != s) {
	                ret = s;
	            } else if (f[s]) {
	                ret = f[s]();
	            } else {
	                ret = s;
	            }
	            return ret;
	        });
	    }),
	
	    strtotime: function strtotime(datetime) {
	        var p = {};
	        p.datetime = datetime || '';
	        datetime = undefined;
	
	        p._ = p.datetime.toString().indexOf(' ') == -1 ? p.datetime.toString().indexOf(':') == -1 ? [p.datetime, ''] : ['', p.datetime] : p.datetime.split(' ');
	        p.ymd = p._[0] || '';
	        p.his = p._[1] || '';
	        p.ymd = p.ymd.toString().indexOf('-') == -1 ? [p.ymd] : p.ymd.split('-');
	        p.his = p.his.toString().indexOf(':') == -1 ? [p.his] : p.his.split(':');
	        p.year = (p.ymd[0] || 0) - 0;
	        p.month = (p.ymd[1] || 0) - 1;
	        p.day = (p.ymd[2] || 0) - 0;
	        p.hour = p.his[0] - 0;
	        p.minute = p.his[1] - 0;
	        p.second = p.his[2] - 0;
	
	        if (p.his[0] == undefined || isNaN(p.hour)) {
	            p.hour = 0;
	        }
	        if (p.his[1] == undefined || isNaN(p.minute)) {
	            p.minute = 0;
	        }
	        if (p.his[2] == undefined || isNaN(p.second)) {
	            p.second = 0;
	        }
	        p.time = new Date(p.year, p.month, p.day, p.hour, p.minute, p.second).getTime();
	        p = parseInt(p.time);
	
	        return p;
	    },
	
	    now: function now() {
	        return new Date().getTime();
	    },
	
	    time: function time() {
	        return parseInt(this.now() / 1000);
	    },
	
	    isEmpty: function isEmpty(value) {
	        if (value === null || value === undefined || value === '' || value === false) {
	            return true;
	        }
	
	        if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object' && (0, _getOwnPropertyNames2.default)(value).length === 0) {
	            return true;
	        }
	
	        return false;
	    },
	
	    url: {
	        query: function query() {
	            var __url = '';
	            if (location.href.indexOf('?') >= 0) {
	                __url = location.href.substring(location.href.indexOf('?'));
	            }
	            var str = __url.substr(1);
	
	            if (str.indexOf('#') >= 0) {
	                str = str.split('#')[0];
	            }
	
	            var UrlObj = {},
	                urlArr = str.split('&');
	
	            if (str === "") return UrlObj;
	
	            for (var i = 0, len = urlArr.length; i < len; i++) {
	                var get_Url = urlArr[i].split('='),
	                    url = '';
	
	                for (var j = 0; j < get_Url.length; j++) {
	                    if (j !== 0) {
	                        get_Url[j] = get_Url[j] === "" ? '=' : get_Url[j];
	                        url += get_Url[j];
	                    }
	                }
	
	                UrlObj[get_Url[0]] = url;
	            }
	            return UrlObj;
	        },
	
	        params: function params(query) {
	            return this.query()[query];
	        },
	
	        replaceParamVal: function replaceParamVal(arg, arg_val, url) {
	            if (url === undefined) {
	                url = window.location.href.toString();
	            }
	            var pattern = arg + '=([^&]*)';
	            var replaceText = arg + '=' + arg_val;
	
	            if (url.match(pattern)) {
	                var tmp = '/(' + arg + '=)([^&]*)/gi';
	                tmp = url.replace(eval(tmp), replaceText);
	                return tmp;
	            } else {
	                if (url.match('[\?]')) {
	                    return url + '&' + replaceText;
	                } else {
	                    return url + '?' + replaceText;
	                }
	            }
	        },
	
	        replaceParamVals: function replaceParamVals(params, url) {
	            if (tools.isEmpty(params) && tools.isEmpty(url)) {
	                url = window.location.href.toString();
	            } else {
	                for (var key in params) {
	                    url = this.replaceParamVal(key, params[key], url);
	                }
	            }
	
	            return url;
	        },
	
	        changeUrl: function changeUrl(url, data) {
	            var history = data || {};
	            if (navigator.appName == "Microsoft Internet Explorer" && navigator.appVersion.split(";")[1].replace(/[ ]/g, "") == "MSIE9.0") {} else {
	                window.history.pushState(history, 0, url);
	            }
	        },
	
	        replaceUrl: function replaceUrl(url, data) {
	            var history = data || {};
	            if (navigator.appName == "Microsoft Internet Explorer" && navigator.appVersion.split(";")[1].replace(/[ ]/g, "") == "MSIE9.0") {} else {
	                window.history.replaceState(history, 0, url);
	            }
	        },
	
	        getOrigin: function getOrigin() {
	            var url = '';
	
	            if (!location.port) {
	                url = location.protocol + '//' + location.hostname;
	            } else {
	                url = location.protocol + '//' + location.hostname + ':' + location.port;
	            }
	
	            return url;
	        }
	    },
	
	    cache: {
	        get: function get(key) {
	            return window.localStorage.getItem(key);
	        },
	
	        set: function set(key, value) {
	            return localStorage.setItem(key, value);
	        },
	
	        del: function del(key) {
	            return localStorage.removeItem(key);
	        },
	
	        getSession: function getSession(key) {
	            return sessionStorage.getItem(key);
	        },
	
	        setSession: function setSession(key, value) {
	            return sessionStorage.setItem(key, value);
	        },
	
	        delSession: function delSession(key) {
	            return sessionStorage.removeItem(key);
	        }
	    },
	
	    title: {
	        get: function get() {
	            return document.title;
	        },
	
	        set: function set(value) {
	            return document.title = value;
	        }
	    },
	
	    get: {
	        guid: function guid() {
	            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	                var r = Math.random() * 16 | 0,
	                    v = c == 'x' ? r : r & 0x3 | 0x8;
	                return v.toString(16);
	            });
	        }
	    },
	
	    errorHandle: function errorHandle(data) {
	        var error_data = this.errorData;
	        var flag = true;
	
	        for (var i = 0; i < error_data.length; i++) {
	            var index = i;
	
	            if (data.errcode == error_data[index].errcode) {
	                if (error_data[index].prompt !== undefined && error_data[index].prompt !== '') {
	                    window.tools.alert.message(error_data[index].prompt);
	                }
	
	                if (error_data[index].fun !== '' && typeof error_data[index].fun == 'function') {
	                    error_data[index].fun({ option: data.option });
	                }
	
	                if (error_data[index].url !== undefined && error_data[index].url !== '' && error_data[index].url !== -1) {
	                    var jumpFun;
	                    if (error_data[index].url === true) {
	                        jumpFun = function jumpFun() {
	                            window.location.reload();
	                        };
	                    } else {
	                        jumpFun = function jumpFun() {
	                            window.tools.router.push(error_data[index].url);
	                        };
	                    }
	
	                    setTimeout(jumpFun, 2000);
	                }
	
	                flag = false;
	
	                if (error_data[index].url === -1) {
	                    return true;
	                }
	
	                return false;
	            }
	        }
	        return flag;
	    },
	
	    deleteObj: function deleteObj(obj) {
	        for (var v in obj) {
	            if (obj.hasOwnProperty(v)) {
	                if (obj[v] === "" || obj[v] === undefined || obj[v] === null) {
	                    delete obj[v];
	                }
	            }
	        }
	        return obj;
	    },
	
	    ksort: function ksort(data) {
	        var keys = [],
	            k,
	            i,
	            len;
	
	        for (k in data) {
	            if (data.hasOwnProperty(k)) {
	                keys.push(k);
	            }
	        }
	
	        keys.sort();
	
	        len = keys.length;
	        var obj = {};
	        for (i = 0; i < len; i++) {
	
	            k = keys[i];
	            obj[k] = data[k];
	        }
	        return obj;
	    }
	};

/***/ }),

/***/ 946:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	     value: true
	});
	exports.default = {
	     'distribution/agency/index': function distributionAgencyIndex(resolve) {
	          return __webpack_require__.e/* require */(4, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1885)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/agency/history': function distributionAgencyHistory(resolve) {
	          return __webpack_require__.e/* require */(23, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1884)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'address': function address(resolve) {
	          return __webpack_require__.e/* require */(92, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1828)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'bind_wechat': function bind_wechat(resolve) {
	          return __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(557)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'cart': function cart(resolve) {
	          return __webpack_require__.e/* require */(113, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1831)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'checkoutsuccess': function checkoutsuccess(resolve) {
	          return __webpack_require__.e/* require */(349, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1832)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'checkoutsuccess2': function checkoutsuccess2(resolve) {
	          return __webpack_require__.e/* require */(348, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1833)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'download': function download(resolve) {
	          return __webpack_require__.e/* require */(347, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1836)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'goods_promote': function goods_promote(resolve) {
	          return __webpack_require__.e/* require */(75, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1837)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'goodsdetail': function goodsdetail(resolve) {
	          return __webpack_require__.e/* require */(61, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1838)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'goodsdetail1': function goodsdetail1(resolve) {
	          return __webpack_require__.e/* require */(87, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1839)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'goodsdetail_share': function goodsdetail_share(resolve) {
	          return __webpack_require__.e/* require */(58, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1840)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'index': function index(resolve) {
	          return __webpack_require__.e/* require */(68, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1841)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'intro': function intro(resolve) {
	          return __webpack_require__.e/* require */(346, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1842)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'login': function login(resolve) {
	          return __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(557)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'sharecare/resource/index': function sharecareResourceIndex(resolve) {
	          return __webpack_require__.e/* require */(39, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2038)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'sharecare/resource/doctor/detail': function sharecareResourceDoctorDetail(resolve) {
	          return __webpack_require__.e/* require */(290, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2040)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'sharecare/resource/health/detail': function sharecareResourceHealthDetail(resolve) {
	          return __webpack_require__.e/* require */(289, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2041)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'sharecare/resource/pair/apply': function sharecareResourcePairApply(resolve) {
	          return __webpack_require__.e/* require */(288, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2042)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'sharecare/resource/pair/result': function sharecareResourcePairResult(resolve) {
	          return __webpack_require__.e/* require */(287, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2043)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'sharecare/resource/apply/index': function sharecareResourceApplyIndex(resolve) {
	          return __webpack_require__.e/* require */(57, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2039)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'sharecare/resource/team/index': function sharecareResourceTeamIndex(resolve) {
	          return __webpack_require__.e/* require */(215, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2044)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'agreement': function agreement(resolve) {
	          return __webpack_require__.e/* require */(350, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1830)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'common_register': function common_register(resolve) {
	          return __webpack_require__.e/* require */(50, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1834)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'default_register': function default_register(resolve) {
	          return __webpack_require__.e/* require */(49, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1835)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'loginpassword': function loginpassword(resolve) {
	          return __webpack_require__.e/* require */(41, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1843)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'logistics': function logistics(resolve) {
	          return __webpack_require__.e/* require */(345, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1844)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'register': function register(resolve) {
	          return __webpack_require__.e/* require */(32, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1845)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'sharedetail': function sharedetail(resolve) {
	          return __webpack_require__.e/* require */(344, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1846)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'update': function update(resolve) {
	          return __webpack_require__.e/* require */(343, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1848)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'yunindex': function yunindex(resolve) {
	          return __webpack_require__.e/* require */(90, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1849)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'binding/setloginpwd': function bindingSetloginpwd(resolve) {
	          return __webpack_require__.e/* require */(242, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1854)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'binding/bindsuperior': function bindingBindsuperior(resolve) {
	          return __webpack_require__.e/* require */(341, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1853)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'address/addex': function addressAddex(resolve) {
	          return __webpack_require__.e/* require */(221, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1850)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'address/edit': function addressEdit(resolve) {
	          return __webpack_require__.e/* require */(34, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1851)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'address/list': function addressList(resolve) {
	          return __webpack_require__.e/* require */(342, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1852)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'contract/agreement': function contractAgreement(resolve) {
	          return __webpack_require__.e/* require */(340, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1855)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'contract/index': function contractIndex(resolve) {
	          return __webpack_require__.e/* require */(48, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1856)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'contract/signing': function contractSigning(resolve) {
	          return __webpack_require__.e/* require */(120, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1857)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/auth/authcenter': function distributionAuthAuthcenter(resolve) {
	          return __webpack_require__.e/* require */(16, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1889)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/auth/start': function distributionAuthStart(resolve) {
	          return __webpack_require__.e/* require */(328, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1893)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/auth/authresult': function distributionAuthAuthresult(resolve) {
	          return __webpack_require__.e/* require */(330, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1890)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/auth/authdetail': function distributionAuthAuthdetail(resolve) {
	          return __webpack_require__.e/* require */(329, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1891)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/auth/authinfo': function distributionAuthAuthinfo(resolve) {
	          return __webpack_require__.e/* require */(17, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1892)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/chat': function distributionChat(resolve) {
	          return __webpack_require__.e/* require */(56, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1858)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/cart/index': function distributionCartIndex(resolve) {
	          return __webpack_require__.e/* require */(117, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1898)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/coupon/list': function distributionCouponList(resolve) {
	          return __webpack_require__.e/* require */(89, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1902)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/ckcenter': function distributionCkcenter(resolve) {
	          return __webpack_require__.e/* require */(70, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1859)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/ckcenterlist': function distributionCkcenterlist(resolve) {
	          return __webpack_require__.e/* require */(339, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1860)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/goodscomb': function distributionGoodscomb(resolve) {
	          return __webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1863)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/goodsdetail': function distributionGoodsdetail(resolve) {
	          return __webpack_require__.e/* require */(6, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1864)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/goodsdetail1': function distributionGoodsdetail1(resolve) {
	          return __webpack_require__.e/* require */(86, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1865)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/goodssearch': function distributionGoodssearch(resolve) {
	          return __webpack_require__.e/* require */(14, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1861)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/goodssearchresult': function distributionGoodssearchresult(resolve) {
	          return __webpack_require__.e/* require */(13, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1862)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/identityauth': function distributionIdentityauth(resolve) {
	          return __webpack_require__.e/* require */(136, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1866)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/improveidentity': function distributionImproveidentity(resolve) {
	          return __webpack_require__.e/* require */(135, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1867)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/index': function distributionIndex(resolve) {
	          return __webpack_require__.e/* require */(43, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1868)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/index_old': function distributionIndex_old(resolve) {
	          return __webpack_require__.e/* require */(101, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1869)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/leveldesc': function distributionLeveldesc(resolve) {
	          return __webpack_require__.e/* require */(338, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1870)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/register': function distributionRegister(resolve) {
	          return __webpack_require__.e/* require */(220, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1871)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/retail': function distributionRetail(resolve) {
	          return __webpack_require__.e/* require */(42, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1872)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/theme': function distributionTheme(resolve) {
	          return __webpack_require__.e/* require */(219, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1873)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/activity/arealist': function distributionActivityArealist(resolve) {
	          return __webpack_require__.e/* require */(337, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1874)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/activity/map': function distributionActivityMap(resolve) {
	          return __webpack_require__.e/* require */(333, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1880)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/activity/buysuccess': function distributionActivityBuysuccess(resolve) {
	          return __webpack_require__.e/* require */(336, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1875)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/activity/center': function distributionActivityCenter(resolve) {
	          return __webpack_require__.e/* require */(210, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1876)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/activity/checkconfirm': function distributionActivityCheckconfirm(resolve) {
	          return __webpack_require__.e/* require */(335, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1877)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/activity/details': function distributionActivityDetails(resolve) {
	          return __webpack_require__.e/* require */(5, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1878)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/activity/fail': function distributionActivityFail(resolve) {
	          return __webpack_require__.e/* require */(334, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1879)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/activity/result': function distributionActivityResult(resolve) {
	          return __webpack_require__.e/* require */(332, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1881)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/activity/tickets': function distributionActivityTickets(resolve) {
	          return __webpack_require__.e/* require */(24, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1882)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/activity/index': function distributionActivityIndex(resolve) {
	          return __webpack_require__.e/* require */(20, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1883)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/article/details': function distributionArticleDetails(resolve) {
	          return __webpack_require__.e/* require */(331, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1887)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/article/list': function distributionArticleList(resolve) {
	          return __webpack_require__.e/* require */(100, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1888)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/dispatch/confirm': function distributionDispatchConfirm(resolve) {
	          return __webpack_require__.e/* require */(54, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1903)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/dispatch/confirm2': function distributionDispatchConfirm2(resolve) {
	          return __webpack_require__.e/* require */(112, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1904)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/dispatch/details': function distributionDispatchDetails(resolve) {
	          return __webpack_require__.e/* require */(133, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1905)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/dispatch/details2': function distributionDispatchDetails2(resolve) {
	          return __webpack_require__.e/* require */(218, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1906)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/dispatch/index': function distributionDispatchIndex(resolve) {
	          return __webpack_require__.e/* require */(28, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1907)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/dispatch/list': function distributionDispatchList(resolve) {
	          return __webpack_require__.e/* require */(115, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1908)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/distributionorder/details': function distributionDistributionorderDetails(resolve) {
	          return __webpack_require__.e/* require */(327, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1909)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/distributionorder/list': function distributionDistributionorderList(resolve) {
	          return __webpack_require__.e/* require */(207, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1910)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/distributionorder/list2': function distributionDistributionorderList2(resolve) {
	          return __webpack_require__.e/* require */(206, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1911)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/exchange/index': function distributionExchangeIndex(resolve) {
	          return __webpack_require__.e/* require */(205, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1919)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/exam/list': function distributionExamList(resolve) {
	          return __webpack_require__.e/* require */(121, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1916)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/exam/question': function distributionExamQuestion(resolve) {
	          return __webpack_require__.e/* require */(33, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1917)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/exam/result': function distributionExamResult(resolve) {
	          return __webpack_require__.e/* require */(62, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1918)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/filluporder/details': function distributionFilluporderDetails(resolve) {
	          return __webpack_require__.e/* require */(324, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1920)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/filluporder/list': function distributionFilluporderList(resolve) {
	          return __webpack_require__.e/* require */(204, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1921)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/goodsorder/details': function distributionGoodsorderDetails(resolve) {
	          return __webpack_require__.e/* require */(323, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1922)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/goodsorder/list': function distributionGoodsorderList(resolve) {
	          return __webpack_require__.e/* require */(203, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1923)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/help/details': function distributionHelpDetails(resolve) {
	          return __webpack_require__.e/* require */(145, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1924)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/help/index': function distributionHelpIndex(resolve) {
	          return __webpack_require__.e/* require */(237, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1925)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/help/list': function distributionHelpList(resolve) {
	          return __webpack_require__.e/* require */(99, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1926)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/help/result': function distributionHelpResult(resolve) {
	          return __webpack_require__.e/* require */(12, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1927)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/inventory/details': function distributionInventoryDetails(resolve) {
	          return __webpack_require__.e/* require */(202, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1928)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/inventory/list': function distributionInventoryList(resolve) {
	          return __webpack_require__.e/* require */(35, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1929)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/invite/index': function distributionInviteIndex(resolve) {
	          return __webpack_require__.e/* require */(111, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1930)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/material/details': function distributionMaterialDetails(resolve) {
	          return __webpack_require__.e/* require */(322, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1931)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/material/list': function distributionMaterialList(resolve) {
	          return __webpack_require__.e/* require */(162, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1932)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/materialorder/confirm': function distributionMaterialorderConfirm(resolve) {
	          return __webpack_require__.e/* require */(132, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1933)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/materialorder/details': function distributionMaterialorderDetails(resolve) {
	          return __webpack_require__.e/* require */(321, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1934)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/materialorder/index': function distributionMaterialorderIndex(resolve) {
	          return __webpack_require__.e/* require */(141, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1935)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/materialorder/list': function distributionMaterialorderList(resolve) {
	          return __webpack_require__.e/* require */(201, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1936)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/partner/auditing': function distributionPartnerAuditing(resolve) {
	          return __webpack_require__.e/* require */(153, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1937)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/partner/detail': function distributionPartnerDetail(resolve) {
	          return __webpack_require__.e/* require */(200, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1938)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/partner/index': function distributionPartnerIndex(resolve) {
	          return __webpack_require__.e/* require */(236, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1939)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/partner/inventory': function distributionPartnerInventory(resolve) {
	          return __webpack_require__.e/* require */(199, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1940)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/partner/list': function distributionPartnerList(resolve) {
	          return __webpack_require__.e/* require */(198, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1941)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/partner/list2': function distributionPartnerList2(resolve) {
	          return __webpack_require__.e/* require */(197, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1942)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/partner/studyCourse': function distributionPartnerStudyCourse(resolve) {
	          return __webpack_require__.e/* require */(194, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1947)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/partner/partner_message': function distributionPartnerPartner_message(resolve) {
	          return __webpack_require__.e/* require */(110, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1943)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/partner/potential': function distributionPartnerPotential(resolve) {
	          return __webpack_require__.e/* require */(196, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1944)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/partner/self_order_list': function distributionPartnerSelf_order_list(resolve) {
	          return __webpack_require__.e/* require */(195, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1946)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/partner/self_order_detail': function distributionPartnerSelf_order_detail(resolve) {
	          return __webpack_require__.e/* require */(320, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1945)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/personal/index': function distributionPersonalIndex(resolve) {
	          return __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(558)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/personal/test': function distributionPersonalTest(resolve) {
	          return __webpack_require__.e/* require */(235, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1950)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/personal/info/email': function distributionPersonalInfoEmail(resolve) {
	          return __webpack_require__.e/* require */(234, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1951)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/personal/info/wechat': function distributionPersonalInfoWechat(resolve) {
	          return __webpack_require__.e/* require */(316, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1957)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/personal/info/index': function distributionPersonalInfoIndex(resolve) {
	          return __webpack_require__.e/* require */(26, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1952)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/personal/info/nickname': function distributionPersonalInfoNickname(resolve) {
	          return __webpack_require__.e/* require */(319, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1953)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/personal/info/paypassword': function distributionPersonalInfoPaypassword(resolve) {
	          return __webpack_require__.e/* require */(40, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1954)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/personal/info/phone': function distributionPersonalInfoPhone(resolve) {
	          return __webpack_require__.e/* require */(318, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1955)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/personal/info/signature': function distributionPersonalInfoSignature(resolve) {
	          return __webpack_require__.e/* require */(317, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1956)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/personal/message/details': function distributionPersonalMessageDetails(resolve) {
	          return __webpack_require__.e/* require */(315, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1958)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/personal/message/list': function distributionPersonalMessageList(resolve) {
	          return __webpack_require__.e/* require */(109, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1959)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/personal/message/list2': function distributionPersonalMessageList2(resolve) {
	          return __webpack_require__.e/* require */(108, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1960)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/personal/InitialFee': function distributionPersonalInitialFee(resolve) {
	          return __webpack_require__.e/* require */(142, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1948)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/personal/StudyCourse': function distributionPersonalStudyCourse(resolve) {
	          return __webpack_require__.e/* require */(27, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1949)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/personal/studyCertificate': function distributionPersonalStudyCertificate(resolve) {
	          return __webpack_require__.e/* require */(37, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1961)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/proprietary/index': function distributionProprietaryIndex(resolve) {
	          return __webpack_require__.e/* require */(125, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1962)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/question/details': function distributionQuestionDetails(resolve) {
	          return __webpack_require__.e/* require */(314, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1963)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/question/question': function distributionQuestionQuestion(resolve) {
	          return __webpack_require__.e/* require */(313, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1964)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/retailorder/details': function distributionRetailorderDetails(resolve) {
	          return __webpack_require__.e/* require */(312, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1965)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/retailorder/list': function distributionRetailorderList(resolve) {
	          return __webpack_require__.e/* require */(193, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1966)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/saleorder/details': function distributionSaleorderDetails(resolve) {
	          return __webpack_require__.e/* require */(311, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1967)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/saleorder/list': function distributionSaleorderList(resolve) {
	          return __webpack_require__.e/* require */(192, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1968)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/setting/index': function distributionSettingIndex(resolve) {
	          return __webpack_require__.e/* require */(131, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1969)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/setting/nickname': function distributionSettingNickname(resolve) {
	          return __webpack_require__.e/* require */(310, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1970)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/setting/phone': function distributionSettingPhone(resolve) {
	          return __webpack_require__.e/* require */(309, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1971)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/setting/profit': function distributionSettingProfit(resolve) {
	          return __webpack_require__.e/* require */(308, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1972)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/setting/signature': function distributionSettingSignature(resolve) {
	          return __webpack_require__.e/* require */(307, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1973)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/settle/account': function distributionSettleAccount(resolve) {
	          return __webpack_require__.e/* require */(306, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1974)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/settle/center': function distributionSettleCenter(resolve) {
	          return __webpack_require__.e/* require */(217, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1975)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/settle/index': function distributionSettleIndex(resolve) {
	          return __webpack_require__.e/* require */(216, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1976)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/settle/integralhistory': function distributionSettleIntegralhistory(resolve) {
	          return __webpack_require__.e/* require */(64, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1977)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/settle/list': function distributionSettleList(resolve) {
	          return __webpack_require__.e/* require */(233, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1978)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/settle/month': function distributionSettleMonth(resolve) {
	          return __webpack_require__.e/* require */(161, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1979)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/settle/rule': function distributionSettleRule(resolve) {
	          return __webpack_require__.e/* require */(305, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1980)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/settle/year': function distributionSettleYear(resolve) {
	          return __webpack_require__.e/* require */(160, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1981)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/shoporder/add': function distributionShoporderAdd(resolve) {
	          return __webpack_require__.e/* require */(150, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1982)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/shoporder/checkidentity': function distributionShoporderCheckidentity(resolve) {
	          return __webpack_require__.e/* require */(304, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1983)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/shoporder/confirm': function distributionShoporderConfirm(resolve) {
	          return __webpack_require__.e/* require */(103, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1984)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/shoporder/confirm2': function distributionShoporderConfirm2(resolve) {
	          return __webpack_require__.e/* require */(71, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1985)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/shoporder/confirm3': function distributionShoporderConfirm3(resolve) {
	          return __webpack_require__.e/* require */(102, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1986)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/shoporder/confirmorder': function distributionShoporderConfirmorder(resolve) {
	          return __webpack_require__.e/* require */(159, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1987)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/shoporder/details': function distributionShoporderDetails(resolve) {
	          return __webpack_require__.e/* require */(191, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1988)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/shoporder/details2': function distributionShoporderDetails2(resolve) {
	          return __webpack_require__.e/* require */(190, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1989)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/shoporder/list': function distributionShoporderList(resolve) {
	          return __webpack_require__.e/* require */(53, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1990)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/stock/comblist': function distributionStockComblist(resolve) {
	          return __webpack_require__.e/* require */(303, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1991)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/stock/combsconfirm': function distributionStockCombsconfirm(resolve) {
	          return __webpack_require__.e/* require */(60, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1992)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/stock/confirm': function distributionStockConfirm(resolve) {
	          return __webpack_require__.e/* require */(59, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1993)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/stock/list': function distributionStockList(resolve) {
	          return __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1994)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/stock/listcopy': function distributionStockListcopy(resolve) {
	          return __webpack_require__.e/* require */(19, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1995)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/stockorder/details': function distributionStockorderDetails(resolve) {
	          return __webpack_require__.e/* require */(189, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1996)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/stockorder/list': function distributionStockorderList(resolve) {
	          return __webpack_require__.e/* require */(188, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1997)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/testgoods/goodsdetail': function distributionTestgoodsGoodsdetail(resolve) {
	          return __webpack_require__.e/* require */(85, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1998)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/testgoods/goodsdetail1': function distributionTestgoodsGoodsdetail1(resolve) {
	          return __webpack_require__.e/* require */(84, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1999)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/testgoods/list': function distributionTestgoodsList(resolve) {
	          return __webpack_require__.e/* require */(140, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2000)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/wallet/bankcard': function distributionWalletBankcard(resolve) {
	          return __webpack_require__.e/* require */(302, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2001)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/wallet/binding': function distributionWalletBinding(resolve) {
	          return __webpack_require__.e/* require */(119, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2002)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/wallet/index': function distributionWalletIndex(resolve) {
	          return __webpack_require__.e/* require */(11, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2003)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/wallet/pos': function distributionWalletPos(resolve) {
	          return __webpack_require__.e/* require */(301, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2004)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/wallet/recharge': function distributionWalletRecharge(resolve) {
	          return __webpack_require__.e/* require */(15, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2005)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/wallet/rechargecopy': function distributionWalletRechargecopy(resolve) {
	          return __webpack_require__.e/* require */(300, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2006)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/wallet/record': function distributionWalletRecord(resolve) {
	          return __webpack_require__.e/* require */(187, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2007)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/wallet/ticketconfirm': function distributionWalletTicketconfirm(resolve) {
	          return __webpack_require__.e/* require */(7, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2009)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/wallet/ticketlvconfirm': function distributionWalletTicketlvconfirm(resolve) {
	          return __webpack_require__.e/* require */(10, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2008)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/wallet/withdraw': function distributionWalletWithdraw(resolve) {
	          return __webpack_require__.e/* require */(186, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2010)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/wallet/yearrecord': function distributionWalletYearrecord(resolve) {
	          return __webpack_require__.e/* require */(185, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2011)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/conversion/index': function distributionConversionIndex(resolve) {
	          return __webpack_require__.e/* require */(240, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1900)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/conversion/lists': function distributionConversionLists(resolve) {
	          return __webpack_require__.e/* require */(208, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1901)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/enterprise/certification': function distributionEnterpriseCertification(resolve) {
	          return __webpack_require__.e/* require */(239, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1913)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/enterprise/img-result': function distributionEnterpriseImgResult(resolve) {
	          return __webpack_require__.e/* require */(238, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1915)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/enterprise/check-result': function distributionEnterpriseCheckResult(resolve) {
	          return __webpack_require__.e/* require */(325, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1914)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/enterprise/certification-result': function distributionEnterpriseCertificationResult(resolve) {
	          return __webpack_require__.e/* require */(326, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1912)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/barter/selectBeforeGoods': function distributionBarterSelectBeforeGoods(resolve) {
	          return __webpack_require__.e/* require */(18, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1897)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/barter/selectAfterGoods': function distributionBarterSelectAfterGoods(resolve) {
	          return __webpack_require__.e/* require */(66, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1896)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/barter/orderList': function distributionBarterOrderList(resolve) {
	          return __webpack_require__.e/* require */(134, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1895)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/barter/orderDetail': function distributionBarterOrderDetail(resolve) {
	          return __webpack_require__.e/* require */(209, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1894)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/certificate/poster': function distributionCertificatePoster(resolve) {
	          return __webpack_require__.e/* require */(241, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1899)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'distribution/agency/certificate': function distributionAgencyCertificate(resolve) {
	          return __webpack_require__.e/* require */(116, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1886)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'marketing/help/address/index': function marketingHelpAddressIndex(resolve) {
	          return __webpack_require__.e/* require */(47, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2012)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'marketing/help/index/index': function marketingHelpIndexIndex(resolve) {
	          return __webpack_require__.e/* require */(30, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2013)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'marketing/help/introduced/index': function marketingHelpIntroducedIndex(resolve) {
	          return __webpack_require__.e/* require */(36, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2014)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'marketing/help/joinapply/index': function marketingHelpJoinapplyIndex(resolve) {
	          return __webpack_require__.e/* require */(29, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2015)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'marketing/help/regsuccess/index': function marketingHelpRegsuccessIndex(resolve) {
	          return __webpack_require__.e/* require */(38, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2016)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'marketing/help/register/index': function marketingHelpRegisterIndex(resolve) {
	          return __webpack_require__.e/* require */(184, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2017)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'retail/info/details': function retailInfoDetails(resolve) {
	          return __webpack_require__.e/* require */(299, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2018)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'retail/info/details2': function retailInfoDetails2(resolve) {
	          return __webpack_require__.e/* require */(298, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2019)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'retail/info/list': function retailInfoList(resolve) {
	          return __webpack_require__.e/* require */(98, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2020)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'retail/order/confirm': function retailOrderConfirm(resolve) {
	          return __webpack_require__.e/* require */(232, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2022)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'retail/order/details': function retailOrderDetails(resolve) {
	          return __webpack_require__.e/* require */(297, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2023)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'retail/order/list': function retailOrderList(resolve) {
	          return __webpack_require__.e/* require */(183, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2024)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'retail/order/pay': function retailOrderPay(resolve) {
	          return __webpack_require__.e/* require */(296, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2025)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'retail/order/activitydetail': function retailOrderActivitydetail(resolve) {
	          return __webpack_require__.e/* require */(44, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2021)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'retail/personal/email': function retailPersonalEmail(resolve) {
	          return __webpack_require__.e/* require */(147, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2026)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'retail/personal/index': function retailPersonalIndex(resolve) {
	          return __webpack_require__.e/* require */(155, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2027)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'retail/personal/isdistribution': function retailPersonalIsdistribution(resolve) {
	          return __webpack_require__.e/* require */(231, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2028)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'retail/personal/phone': function retailPersonalPhone(resolve) {
	          return __webpack_require__.e/* require */(52, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2029)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'retail/personal/phone_origin': function retailPersonalPhone_origin(resolve) {
	          return __webpack_require__.e/* require */(295, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2030)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'retail/personal/info/about': function retailPersonalInfoAbout(resolve) {
	          return __webpack_require__.e/* require */(294, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2031)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'retail/personal/info/index': function retailPersonalInfoIndex(resolve) {
	          return __webpack_require__.e/* require */(22, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2032)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'retail/personal/info/nickname': function retailPersonalInfoNickname(resolve) {
	          return __webpack_require__.e/* require */(293, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2033)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'retail/personal/info/signature': function retailPersonalInfoSignature(resolve) {
	          return __webpack_require__.e/* require */(292, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2034)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'retail/personal/message/details': function retailPersonalMessageDetails(resolve) {
	          return __webpack_require__.e/* require */(291, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2035)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'retail/personal/message/list': function retailPersonalMessageList(resolve) {
	          return __webpack_require__.e/* require */(107, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2036)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'retail/testgoods/goodsdetail': function retailTestgoodsGoodsdetail(resolve) {
	          return __webpack_require__.e/* require */(83, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2037)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'TerritoryLists': function TerritoryLists(resolve) {
	          return __webpack_require__.e/* require */(8, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1847)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'AgencyLists': function AgencyLists(resolve) {
	          return __webpack_require__.e/* require */(9, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1829)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/address': function vietnamAddress(resolve) {
	          return __webpack_require__.e/* require */(91, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2045)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/bind_wechat': function vietnamBind_wechat(resolve) {
	          return __webpack_require__.e/* require */(46, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2046)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/goodsdetail': function vietnamGoodsdetail(resolve) {
	          return __webpack_require__.e/* require */(82, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2047)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/goodsdetail1': function vietnamGoodsdetail1(resolve) {
	          return __webpack_require__.e/* require */(81, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2048)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/goodsdetail_share': function vietnamGoodsdetail_share(resolve) {
	          return __webpack_require__.e/* require */(74, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2049)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/index': function vietnamIndex(resolve) {
	          return __webpack_require__.e/* require */(67, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2050)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/intro': function vietnamIntro(resolve) {
	          return __webpack_require__.e/* require */(286, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2051)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/login': function vietnamLogin(resolve) {
	          return __webpack_require__.e/* require */(45, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2052)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/loginpassword': function vietnamLoginpassword(resolve) {
	          return __webpack_require__.e/* require */(144, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2053)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/logistics': function vietnamLogistics(resolve) {
	          return __webpack_require__.e/* require */(285, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2054)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/register': function vietnamRegister(resolve) {
	          return __webpack_require__.e/* require */(31, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2055)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/sharedetail': function vietnamSharedetail(resolve) {
	          return __webpack_require__.e/* require */(284, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2056)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/update': function vietnamUpdate(resolve) {
	          return __webpack_require__.e/* require */(283, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2057)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/yunindex': function vietnamYunindex(resolve) {
	          return __webpack_require__.e/* require */(88, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2058)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/address/addex': function vietnamAddressAddex(resolve) {
	          return __webpack_require__.e/* require */(214, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2059)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/address/edit': function vietnamAddressEdit(resolve) {
	          return __webpack_require__.e/* require */(76, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2060)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/address/list': function vietnamAddressList(resolve) {
	          return __webpack_require__.e/* require */(282, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2061)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/chat': function vietnamDistributionChat(resolve) {
	          return __webpack_require__.e/* require */(55, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2062)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/ckcenter': function vietnamDistributionCkcenter(resolve) {
	          return __webpack_require__.e/* require */(69, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2063)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/ckcenterlist': function vietnamDistributionCkcenterlist(resolve) {
	          return __webpack_require__.e/* require */(281, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2064)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/goodscomb': function vietnamDistributionGoodscomb(resolve) {
	          return __webpack_require__.e/* require */(73, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2065)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/goodsdetail': function vietnamDistributionGoodsdetail(resolve) {
	          return __webpack_require__.e/* require */(72, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2066)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/goodsdetail1': function vietnamDistributionGoodsdetail1(resolve) {
	          return __webpack_require__.e/* require */(80, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2067)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/identityauth': function vietnamDistributionIdentityauth(resolve) {
	          return __webpack_require__.e/* require */(130, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2068)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/improveidentity': function vietnamDistributionImproveidentity(resolve) {
	          return __webpack_require__.e/* require */(129, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2069)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/index': function vietnamDistributionIndex(resolve) {
	          return __webpack_require__.e/* require */(65, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2070)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/index_old': function vietnamDistributionIndex_old(resolve) {
	          return __webpack_require__.e/* require */(97, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2071)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/leveldesc': function vietnamDistributionLeveldesc(resolve) {
	          return __webpack_require__.e/* require */(280, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2072)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/register': function vietnamDistributionRegister(resolve) {
	          return __webpack_require__.e/* require */(213, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2073)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/retail': function vietnamDistributionRetail(resolve) {
	          return __webpack_require__.e/* require */(182, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2074)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/theme': function vietnamDistributionTheme(resolve) {
	          return __webpack_require__.e/* require */(230, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2075)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/article/details': function vietnamDistributionArticleDetails(resolve) {
	          return __webpack_require__.e/* require */(279, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2076)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/article/list': function vietnamDistributionArticleList(resolve) {
	          return __webpack_require__.e/* require */(96, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2077)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/dispatch/confirm': function vietnamDistributionDispatchConfirm(resolve) {
	          return __webpack_require__.e/* require */(93, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2078)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/dispatch/details': function vietnamDistributionDispatchDetails(resolve) {
	          return __webpack_require__.e/* require */(212, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2079)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/dispatch/index': function vietnamDistributionDispatchIndex(resolve) {
	          return __webpack_require__.e/* require */(181, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2080)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/dispatch/list': function vietnamDistributionDispatchList(resolve) {
	          return __webpack_require__.e/* require */(152, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2081)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/distributionorder/details': function vietnamDistributionDistributionorderDetails(resolve) {
	          return __webpack_require__.e/* require */(278, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2082)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/distributionorder/list': function vietnamDistributionDistributionorderList(resolve) {
	          return __webpack_require__.e/* require */(180, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2083)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/distributionorder/list2': function vietnamDistributionDistributionorderList2(resolve) {
	          return __webpack_require__.e/* require */(179, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2084)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/filluporder/details': function vietnamDistributionFilluporderDetails(resolve) {
	          return __webpack_require__.e/* require */(277, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2085)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/filluporder/list': function vietnamDistributionFilluporderList(resolve) {
	          return __webpack_require__.e/* require */(178, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2086)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/goodsorder/details': function vietnamDistributionGoodsorderDetails(resolve) {
	          return __webpack_require__.e/* require */(276, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2087)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/goodsorder/list': function vietnamDistributionGoodsorderList(resolve) {
	          return __webpack_require__.e/* require */(177, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2088)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/help/details': function vietnamDistributionHelpDetails(resolve) {
	          return __webpack_require__.e/* require */(275, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2089)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/help/index': function vietnamDistributionHelpIndex(resolve) {
	          return __webpack_require__.e/* require */(229, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2090)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/help/list': function vietnamDistributionHelpList(resolve) {
	          return __webpack_require__.e/* require */(95, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2091)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/inventory/details': function vietnamDistributionInventoryDetails(resolve) {
	          return __webpack_require__.e/* require */(176, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2092)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/inventory/list': function vietnamDistributionInventoryList(resolve) {
	          return __webpack_require__.e/* require */(175, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2093)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/invite/index': function vietnamDistributionInviteIndex(resolve) {
	          return __webpack_require__.e/* require */(274, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2094)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/material/list': function vietnamDistributionMaterialList(resolve) {
	          return __webpack_require__.e/* require */(174, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2095)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/materialorder/confirm': function vietnamDistributionMaterialorderConfirm(resolve) {
	          return __webpack_require__.e/* require */(128, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2096)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/materialorder/details': function vietnamDistributionMaterialorderDetails(resolve) {
	          return __webpack_require__.e/* require */(273, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2097)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/materialorder/index': function vietnamDistributionMaterialorderIndex(resolve) {
	          return __webpack_require__.e/* require */(139, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2098)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/materialorder/list': function vietnamDistributionMaterialorderList(resolve) {
	          return __webpack_require__.e/* require */(173, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2099)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/partner/auditing': function vietnamDistributionPartnerAuditing(resolve) {
	          return __webpack_require__.e/* require */(158, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2100)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/partner/index': function vietnamDistributionPartnerIndex(resolve) {
	          return __webpack_require__.e/* require */(272, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2101)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/partner/inventory': function vietnamDistributionPartnerInventory(resolve) {
	          return __webpack_require__.e/* require */(172, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2102)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/partner/list': function vietnamDistributionPartnerList(resolve) {
	          return __webpack_require__.e/* require */(171, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2103)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/partner/list2': function vietnamDistributionPartnerList2(resolve) {
	          return __webpack_require__.e/* require */(170, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2104)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/partner/potential': function vietnamDistributionPartnerPotential(resolve) {
	          return __webpack_require__.e/* require */(169, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2105)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/personal/index': function vietnamDistributionPersonalIndex(resolve) {
	          return __webpack_require__.e/* require */(148, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2106)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/personal/test': function vietnamDistributionPersonalTest(resolve) {
	          return __webpack_require__.e/* require */(271, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2107)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/personal/info/email': function vietnamDistributionPersonalInfoEmail(resolve) {
	          return __webpack_require__.e/* require */(228, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2108)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/personal/info/index': function vietnamDistributionPersonalInfoIndex(resolve) {
	          return __webpack_require__.e/* require */(25, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2109)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/personal/info/nickname': function vietnamDistributionPersonalInfoNickname(resolve) {
	          return __webpack_require__.e/* require */(270, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2110)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/personal/info/paypassword': function vietnamDistributionPersonalInfoPaypassword(resolve) {
	          return __webpack_require__.e/* require */(143, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2111)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/personal/info/phone': function vietnamDistributionPersonalInfoPhone(resolve) {
	          return __webpack_require__.e/* require */(269, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2112)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/personal/info/signature': function vietnamDistributionPersonalInfoSignature(resolve) {
	          return __webpack_require__.e/* require */(268, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2113)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/personal/message/details': function vietnamDistributionPersonalMessageDetails(resolve) {
	          return __webpack_require__.e/* require */(267, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2114)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/personal/message/list': function vietnamDistributionPersonalMessageList(resolve) {
	          return __webpack_require__.e/* require */(106, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2115)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/personal/message/list2': function vietnamDistributionPersonalMessageList2(resolve) {
	          return __webpack_require__.e/* require */(105, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2116)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/proprietary/index': function vietnamDistributionProprietaryIndex(resolve) {
	          return __webpack_require__.e/* require */(124, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2117)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/question/details': function vietnamDistributionQuestionDetails(resolve) {
	          return __webpack_require__.e/* require */(266, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2118)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/question/question': function vietnamDistributionQuestionQuestion(resolve) {
	          return __webpack_require__.e/* require */(265, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2119)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/retailorder/details': function vietnamDistributionRetailorderDetails(resolve) {
	          return __webpack_require__.e/* require */(264, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2120)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/retailorder/list': function vietnamDistributionRetailorderList(resolve) {
	          return __webpack_require__.e/* require */(168, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2121)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/setting/index': function vietnamDistributionSettingIndex(resolve) {
	          return __webpack_require__.e/* require */(127, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2122)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/setting/nickname': function vietnamDistributionSettingNickname(resolve) {
	          return __webpack_require__.e/* require */(263, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2123)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/setting/phone': function vietnamDistributionSettingPhone(resolve) {
	          return __webpack_require__.e/* require */(262, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2124)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/setting/profit': function vietnamDistributionSettingProfit(resolve) {
	          return __webpack_require__.e/* require */(261, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2125)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/setting/signature': function vietnamDistributionSettingSignature(resolve) {
	          return __webpack_require__.e/* require */(260, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2126)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/settle/account': function vietnamDistributionSettleAccount(resolve) {
	          return __webpack_require__.e/* require */(259, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2127)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/settle/center': function vietnamDistributionSettleCenter(resolve) {
	          return __webpack_require__.e/* require */(227, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2128)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/settle/index': function vietnamDistributionSettleIndex(resolve) {
	          return __webpack_require__.e/* require */(226, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2129)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/settle/integralhistory': function vietnamDistributionSettleIntegralhistory(resolve) {
	          return __webpack_require__.e/* require */(63, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2130)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/settle/list': function vietnamDistributionSettleList(resolve) {
	          return __webpack_require__.e/* require */(225, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2131)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/settle/month': function vietnamDistributionSettleMonth(resolve) {
	          return __webpack_require__.e/* require */(157, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2132)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/settle/rule': function vietnamDistributionSettleRule(resolve) {
	          return __webpack_require__.e/* require */(258, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2133)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/settle/year': function vietnamDistributionSettleYear(resolve) {
	          return __webpack_require__.e/* require */(156, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2134)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/shoporder/add': function vietnamDistributionShoporderAdd(resolve) {
	          return __webpack_require__.e/* require */(149, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2135)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/shoporder/confirm': function vietnamDistributionShoporderConfirm(resolve) {
	          return __webpack_require__.e/* require */(126, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2136)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/shoporder/details': function vietnamDistributionShoporderDetails(resolve) {
	          return __webpack_require__.e/* require */(211, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2137)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/shoporder/list': function vietnamDistributionShoporderList(resolve) {
	          return __webpack_require__.e/* require */(151, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2138)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/stock/comblist': function vietnamDistributionStockComblist(resolve) {
	          return __webpack_require__.e/* require */(257, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2139)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/stock/combsconfirm': function vietnamDistributionStockCombsconfirm(resolve) {
	          return __webpack_require__.e/* require */(123, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2140)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/stock/confirm': function vietnamDistributionStockConfirm(resolve) {
	          return __webpack_require__.e/* require */(122, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2141)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/stock/list': function vietnamDistributionStockList(resolve) {
	          return __webpack_require__.e/* require */(138, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2142)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/testgoods/goodsdetail': function vietnamDistributionTestgoodsGoodsdetail(resolve) {
	          return __webpack_require__.e/* require */(79, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2143)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/testgoods/goodsdetail1': function vietnamDistributionTestgoodsGoodsdetail1(resolve) {
	          return __webpack_require__.e/* require */(78, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2144)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/testgoods/list': function vietnamDistributionTestgoodsList(resolve) {
	          return __webpack_require__.e/* require */(137, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2145)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/wallet/bankcard': function vietnamDistributionWalletBankcard(resolve) {
	          return __webpack_require__.e/* require */(256, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2146)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/wallet/binding': function vietnamDistributionWalletBinding(resolve) {
	          return __webpack_require__.e/* require */(118, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2147)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/wallet/index': function vietnamDistributionWalletIndex(resolve) {
	          return __webpack_require__.e/* require */(167, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2148)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/wallet/pos': function vietnamDistributionWalletPos(resolve) {
	          return __webpack_require__.e/* require */(255, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2149)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/wallet/recharge': function vietnamDistributionWalletRecharge(resolve) {
	          return __webpack_require__.e/* require */(254, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2150)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/wallet/rechargecopy': function vietnamDistributionWalletRechargecopy(resolve) {
	          return __webpack_require__.e/* require */(253, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2151)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/wallet/record': function vietnamDistributionWalletRecord(resolve) {
	          return __webpack_require__.e/* require */(166, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2152)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/wallet/withdraw': function vietnamDistributionWalletWithdraw(resolve) {
	          return __webpack_require__.e/* require */(165, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2153)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/distribution/wallet/yearrecord': function vietnamDistributionWalletYearrecord(resolve) {
	          return __webpack_require__.e/* require */(164, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2154)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/retail/cart': function vietnamRetailCart(resolve) {
	          return __webpack_require__.e/* require */(114, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2155)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/retail/info/details': function vietnamRetailInfoDetails(resolve) {
	          return __webpack_require__.e/* require */(252, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2156)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/retail/info/details2': function vietnamRetailInfoDetails2(resolve) {
	          return __webpack_require__.e/* require */(251, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2157)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/retail/info/list': function vietnamRetailInfoList(resolve) {
	          return __webpack_require__.e/* require */(94, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2158)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/retail/order/confirm': function vietnamRetailOrderConfirm(resolve) {
	          return __webpack_require__.e/* require */(224, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2159)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/retail/order/details': function vietnamRetailOrderDetails(resolve) {
	          return __webpack_require__.e/* require */(250, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2160)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/retail/order/list': function vietnamRetailOrderList(resolve) {
	          return __webpack_require__.e/* require */(163, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2161)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/retail/order/pay': function vietnamRetailOrderPay(resolve) {
	          return __webpack_require__.e/* require */(249, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2162)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/retail/personal/email': function vietnamRetailPersonalEmail(resolve) {
	          return __webpack_require__.e/* require */(146, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2163)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/retail/personal/index': function vietnamRetailPersonalIndex(resolve) {
	          return __webpack_require__.e/* require */(154, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2164)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/retail/personal/isdistribution': function vietnamRetailPersonalIsdistribution(resolve) {
	          return __webpack_require__.e/* require */(223, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2165)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/retail/personal/phone': function vietnamRetailPersonalPhone(resolve) {
	          return __webpack_require__.e/* require */(51, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2166)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/retail/personal/phone_origin': function vietnamRetailPersonalPhone_origin(resolve) {
	          return __webpack_require__.e/* require */(248, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2167)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/retail/personal/info/about': function vietnamRetailPersonalInfoAbout(resolve) {
	          return __webpack_require__.e/* require */(247, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2168)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/retail/personal/info/index': function vietnamRetailPersonalInfoIndex(resolve) {
	          return __webpack_require__.e/* require */(21, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2169)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/retail/personal/info/nickname': function vietnamRetailPersonalInfoNickname(resolve) {
	          return __webpack_require__.e/* require */(246, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2170)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/retail/personal/info/signature': function vietnamRetailPersonalInfoSignature(resolve) {
	          return __webpack_require__.e/* require */(245, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2171)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/retail/personal/message/details': function vietnamRetailPersonalMessageDetails(resolve) {
	          return __webpack_require__.e/* require */(244, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2172)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/retail/personal/message/list': function vietnamRetailPersonalMessageList(resolve) {
	          return __webpack_require__.e/* require */(104, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2173)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'vietnam/retail/testgoods/goodsdetail': function vietnamRetailTestgoodsGoodsdetail(resolve) {
	          return __webpack_require__.e/* require */(77, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2174)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	
	     '/': function _(resolve) {
	          return __webpack_require__.e/* require */(1/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(558)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     }
	};

/***/ }),

/***/ 947:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {};

/***/ }),

/***/ 948:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'example/socket': function exampleSocket(resolve) {
	        return __webpack_require__.e/* require */(243, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1827)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	};

/***/ }),

/***/ 949:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    lists: ['/distribution/goodscomb', '/distribution/goodsdetail', '/sharedetail', '/update', '/login', '/register', '/bind_wechat', '/goodsdetail_share', '/distribution/help/details', '/yunindex', '/goods_promote', '/download', '/distribution/exchange/index', '/marketing/help/index/index', '/marketing/help/introduced/index', '/marketing/help/joinapply/index', '/retail/order/activitydetail', '/distribution/activity/details', '/agreement', '/common_register', '/default_register', '/binding/setloginpwd', '/binding/bindsuperior', '/distribution/activity/map'],
	    isUrl: function isUrl(url, type) {
	        var sym = '==';
	        if (type) {
	            sym = type;
	        }
	        var that = this;
	        var noLoginUrls = '';
	        for (var i = 0; i < that.lists.length; i++) {
	            if (i == 0) {
	                noLoginUrls += '"' + url + '"' + sym + '"' + that.lists[i] + '"';
	            } else {
	                noLoginUrls += '||' + '"' + url + '"' + sym + '"' + that.lists[i] + '"';
	            }
	        }
	        return eval(noLoginUrls);
	    }
	};

/***/ }),

/***/ 950:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '404': function _(resolve) {
	        return __webpack_require__.e/* require */(222, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1816)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	};

/***/ }),

/***/ 1374:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1375:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1376:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1410:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1444:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1741:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1815:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1444)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(577),
	  /* template */
	  __webpack_require__(2241),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1817:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1410)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(579),
	  /* template */
	  __webpack_require__(2207),
	  /* scopeId */
	  "data-v-12a1c722",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 2207:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.show_keyboard) ? _c('div', {
	    attrs: {
	      "i": "keyboard"
	    }
	  }, [_c('div', {
	    staticClass: "mask",
	    class: {
	      'show-mask': _vm.show_keyboard_content
	    },
	    on: {
	      "click": _vm.closeKeyboard
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "keyboard",
	    class: {
	      'keyboard-active': _vm.show_keyboard_content
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('div', {
	    staticClass: "keyboard-head verticle-center"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.exinfo) ? _c('span', {
	    staticClass: "keyboard-exinfo",
	    on: {
	      "click": function($event) {
	        return _vm.toUrl(_vm.exinfo.url)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.exinfo.title))]) : _vm._e()]), _vm._v(" "), _c('ul', {
	    staticClass: "keyboard-password verticle-center"
	  }, [_c('li', {
	    staticClass: "verticle-center flex-1"
	  }, [(_vm.keyboardValue.length >= 1) ? _c('i') : _vm._e()]), _vm._v(" "), _c('li', {
	    staticClass: "verticle-center flex-1"
	  }, [(_vm.keyboardValue.length >= 2) ? _c('i') : _vm._e()]), _vm._v(" "), _c('li', {
	    staticClass: "verticle-center flex-1"
	  }, [(_vm.keyboardValue.length >= 3) ? _c('i') : _vm._e()]), _vm._v(" "), _c('li', {
	    staticClass: "verticle-center flex-1"
	  }, [(_vm.keyboardValue.length >= 4) ? _c('i') : _vm._e()]), _vm._v(" "), _c('li', {
	    staticClass: "verticle-center flex-1"
	  }, [(_vm.keyboardValue.length >= 5) ? _c('i') : _vm._e()]), _vm._v(" "), _c('li', {
	    staticClass: "verticle-center flex-1"
	  }, [(_vm.keyboardValue.length >= 6) ? _c('i') : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "keyboard-content"
	  }, [_c('ul', {
	    staticClass: "keyboard-numbers"
	  }, [_c('li', {
	    staticClass: "verticle-center"
	  }, [_c('div', {
	    staticClass: "keyboard-number verticle-center flex-1",
	    on: {
	      "click": function($event) {
	        return _vm.chooseNum(1)
	      }
	    }
	  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
	    staticClass: "keyboard-number verticle-center flex-1",
	    on: {
	      "click": function($event) {
	        return _vm.chooseNum(2)
	      }
	    }
	  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
	    staticClass: "keyboard-number verticle-center flex-1",
	    on: {
	      "click": function($event) {
	        return _vm.chooseNum(3)
	      }
	    }
	  }, [_vm._v("3")])]), _vm._v(" "), _c('li', {
	    staticClass: "verticle-center"
	  }, [_c('div', {
	    staticClass: "keyboard-number verticle-center flex-1",
	    on: {
	      "click": function($event) {
	        return _vm.chooseNum(4)
	      }
	    }
	  }, [_vm._v("4")]), _vm._v(" "), _c('div', {
	    staticClass: "keyboard-number verticle-center flex-1",
	    on: {
	      "click": function($event) {
	        return _vm.chooseNum(5)
	      }
	    }
	  }, [_vm._v("5")]), _vm._v(" "), _c('div', {
	    staticClass: "keyboard-number verticle-center flex-1",
	    on: {
	      "click": function($event) {
	        return _vm.chooseNum(6)
	      }
	    }
	  }, [_vm._v("6")])]), _vm._v(" "), _c('li', {
	    staticClass: "verticle-center"
	  }, [_c('div', {
	    staticClass: "keyboard-number verticle-center flex-1",
	    on: {
	      "click": function($event) {
	        return _vm.chooseNum(7)
	      }
	    }
	  }, [_vm._v("7")]), _vm._v(" "), _c('div', {
	    staticClass: "keyboard-number verticle-center flex-1",
	    on: {
	      "click": function($event) {
	        return _vm.chooseNum(8)
	      }
	    }
	  }, [_vm._v("8")]), _vm._v(" "), _c('div', {
	    staticClass: "keyboard-number verticle-center flex-1",
	    on: {
	      "click": function($event) {
	        return _vm.chooseNum(9)
	      }
	    }
	  }, [_vm._v("9")])]), _vm._v(" "), _c('li', {
	    staticClass: "verticle-center"
	  }, [_c('div', {
	    staticClass: "keyboard-number verticle-center flex-1",
	    on: {
	      "click": _vm.closeKeyboard
	    }
	  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
	    staticClass: "keyboard-number verticle-center flex-1",
	    on: {
	      "click": function($event) {
	        return _vm.chooseNum(0)
	      }
	    }
	  }, [_vm._v("0")]), _vm._v(" "), _c('div', {
	    staticClass: "keyboard-number verticle-center flex-1",
	    on: {
	      "click": _vm.deleteNum
	    }
	  })])])])])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 2241:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: _vm.animotion ? 'fixed' : '',
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.is_subscribe == 0),
	      expression: "is_subscribe == 0"
	    }],
	    staticClass: "top-prompt",
	    on: {
	      "click": _vm.showQRcode
	    }
	  }, [_c('i', {
	    staticClass: "pull-left ionicons ion-ios-information mr10"
	  }), _vm._v(" "), (!_vm.is_vietnam) ? [_c('span', {
	    staticClass: "pull-left"
	  }, [_vm._v("您还没关注公众号，快来关注我吧！")]), _vm._v(" "), _c('button', [_vm._v("关注")])] : [_c('span', {
	    staticClass: "pull-left"
	  }, [_vm._v("Bạn không quan tâm đến công chúng, hãy đến và theo dõi tôi!")]), _vm._v(" "), _c('button', [_vm._v("Sự quan tâm")])]], 2), _vm._v(" "), _c('router-view', {
	    class: {
	      'none-subscribe': _vm.is_subscribe == 0
	    },
	    attrs: {
	      "foot_type": _vm.foot_type,
	      "is_wifi": _vm.is_wifi
	    }
	  }), _vm._v(" "), (_vm.wrap) ? _c('div', {
	    staticClass: "wrap",
	    on: {
	      "touchmove": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [_c('div', {
	    staticClass: "QR-code"
	  }, [_c('i', {
	    staticClass: "close ionicons ion-ios-close-outline",
	    on: {
	      "click": _vm.showQRcode
	    }
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', [_c('img', {
	    attrs: {
	      "src": _vm.img_path,
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("长按二维码，关注我们")])])]) : _vm._e(), _vm._v(" "), (_vm.showkefu) ? _c('div', {
	    ref: "kefu",
	    staticClass: "h-navi",
	    style: ([{
	      'bottom': _vm.bottomValue + 'px'
	    }, {
	      'right': _vm.rightValue + 'px'
	    }]),
	    attrs: {
	      "i": "navigation"
	    },
	    on: {
	      "touchmove": _vm.touchmove,
	      "touchstart": _vm.touchstart,
	      "touchend": _vm.touchend
	    }
	  }, [(!_vm.is_vietnam) ? _c('a', {
	    staticClass: "h-service m-size",
	    on: {
	      "click": function($event) {
	        return _vm.toKefu()
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.is_vietnam) ? _c('a', {
	    staticClass: "h-service m-size",
	    staticStyle: {
	      "background-image": "url(/static/images/vietnam/hover_service@3x.png)"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.toKefu()
	      }
	    }
	  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show_alert),
	      expression: "show_alert"
	    }],
	    staticClass: "base-props-box"
	  }, [_c('div', {
	    staticClass: "props",
	    on: {
	      "touchmove": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "alert-a",
	    on: {
	      "touchmove": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [_c('div', {
	    staticClass: "middle-center"
	  }, [_c('p', {
	    staticClass: "text-center"
	  }, [_vm._v("温馨提示")]), _vm._v(" "), _c('p', [_vm._v("检测到您还未完善实名信息，为了更好的为您提供更多服务，请移步完善！")]), _vm._v(" "), _c('div', {
	    staticClass: "div-btns clearfix"
	  }, [_c('a', {
	    staticClass: "pull-left",
	    on: {
	      "click": function($event) {
	        _vm.show_alert = false
	      }
	    }
	  }, [_vm._v("下次再说")]), _vm._v(" "), _c('a', {
	    staticClass: "pull-right",
	    on: {
	      "click": function($event) {
	        return _vm.toInfo()
	      }
	    }
	  }, [_vm._v("前往完善")])])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show_prop),
	      expression: "show_prop"
	    }],
	    staticClass: "base-props-box"
	  }, [_c('div', {
	    staticClass: "props"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "alert-a"
	  }, [_c('div', {
	    staticClass: "middle-center"
	  }, [_c('p', {
	    staticClass: "text-center"
	  }, [_vm._v("温馨提示")]), _vm._v(" "), _c('p', [_vm._v("此常住地无需与身份证地址相同，请选择您从事商业活动和日常生活所在地，如有变更，可在个人设置中修改")]), _vm._v(" "), _c('div', {
	    staticClass: "div-btns clearfix"
	  }, [_c('a', {
	    staticClass: "pull-right",
	    on: {
	      "click": function($event) {
	        return _vm.toAddress()
	      }
	    }
	  }, [_vm._v("前往设置")])])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show_esign),
	      expression: "show_esign"
	    }],
	    staticClass: "base-props-box"
	  }, [_c('div', {
	    staticClass: "props"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "alert-a"
	  }, [_c('div', {
	    staticClass: "middle-center"
	  }, [_c('p', {
	    staticClass: "text-center"
	  }, [_vm._v("温馨提示")]), _vm._v(" "), _c('p', [_vm._v("恭喜您成为生命说加盟商，为了保护您的权益，快去签署《加盟商合同》吧！")]), _vm._v(" "), _c('div', {
	    staticClass: "div-btns clearfix"
	  }, [_c('a', {
	    staticClass: "pull-right",
	    on: {
	      "click": function($event) {
	        return _vm.toUrl('/contract/index')
	      }
	    }
	  }, [_vm._v("去签署")])])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.bind_superior),
	      expression: "bind_superior"
	    }],
	    staticClass: "alert-box"
	  }, [_c('div', {
	    staticClass: "alert-mk"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "alert-cont"
	  }, [_c('div', {
	    staticClass: "cont-title"
	  }, [_vm._v("提醒信息")]), _vm._v(" "), _c('div', {
	    staticClass: "cont-img"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "cont-phone"
	  }, [_vm._v("绑定推荐人，可享更多服务")]), _vm._v(" "), _c('div', {
	    staticClass: "alert-btn-group"
	  }, [_c('div', {
	    staticClass: "alert-btn-cancel",
	    on: {
	      "click": function($event) {
	        _vm.bind_superior = false
	      }
	    }
	  }, [_vm._v("稍候绑定")]), _vm._v(" "), _c('div', {
	    staticClass: "alert-btn-confirm",
	    on: {
	      "click": _vm.handelBindSuperior
	    }
	  }, [_vm._v("立即绑定")])])])]), _vm._v(" "), (_vm.advertise.lists.length) ? _c('div', {
	    staticClass: "middle-eject"
	  }, [_c('div', {
	    staticClass: "back"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "advertise"
	  }, [_c('div', {
	    staticClass: "close-adver",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.changeBack()
	      }
	    }
	  }, [_vm._v("跳过")]), _vm._v(" "), _c('div', {
	    staticClass: "adver-content",
	    style: (("background-image:url(" + (_vm.advertise.back.cover) + ");")),
	    on: {
	      "click": function($event) {
	        return _vm.goOutsideUrl(_vm.advertise.back)
	      }
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.giftGoods.length > 0) ? _c('div', {
	    staticClass: "remind-box"
	  }, [_c('div', {
	    staticClass: "mask"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "del-icon",
	    on: {
	      "click": function($event) {
	        _vm.giftGoods = []
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "remind-title"
	  }, [_vm._v("赠品到期提醒")]), _vm._v(" "), _c('div', {
	    staticClass: "remind-desc"
	  }, [_vm._v("以下云仓中赠品请尽快自提，超时未自提将自动扣除：")]), _vm._v(" "), _c('div', {
	    staticClass: "goods-box"
	  }, _vm._l((_vm.giftGoods), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "goods-item"
	    }, [_c('div', {
	      staticClass: "goods"
	    }, [_c('div', {
	      staticClass: "cover",
	      style: ({
	        'background-image': 'url(' + item.cover + ')'
	      })
	    }), _vm._v(" "), _c('div', {
	      staticClass: "info"
	    }, [_c('div', {
	      staticClass: "goods-name"
	    }, [_vm._v(_vm._s(item.goods_name))]), _vm._v(" "), _c('div', [_c('div', {
	      staticClass: "num"
	    }, [_vm._v("x " + _vm._s(item.gift_num))]), _vm._v(" "), _c('div', {
	      staticClass: "date"
	    }, [_vm._v("失效时间:" + _vm._s(item.expires_time))])])])])])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "remind-btn",
	    on: {
	      "click": function($event) {
	        _vm.giftGoods = [];
	        _vm.toUrl('/distribution/dispatch/index')
	      }
	    }
	  }, [_vm._v("立即自提")])])]) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', [_c('span', [_vm._v("生命说商城")])])
	}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.3e003951183dcf312e50.js